<template>
    <ortho-nav-bar :action="currentAction" :iaActive="iaActive" :message="statusMessage"></ortho-nav-bar>
    <div ref="threejsContainer" class="threejs-canvas-container">
    </div>

    <!-- Bottom Bar -->
    <ortho-3d-bottom-bar :items="bottomBarItems" @action="performAction" bottom />

    <!-- Sidebar -->
    <ortho-3d-side-bar :items="sideBarItems" @action="performAction" @file-selected="handleFileSelected"
        @object-clicked-in-list="handleObjectClickFromList" @tooth-clicked-in-list="handleToothClicked"
        @colorChanged="handleColorChange" @mode="updateMode" :mode="currentMode" :dental-map="dentalMap"
        @filter-meshes="filterMeshes" />

    <v-dialog v-model="showDialog" persistent max-width="500px">
        <v-card>
            <v-card-title>{{ $t('instructions') }}</v-card-title>
            <v-card-text>
                {{ $t('planeInstructions') }}
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" text @click="showDialog = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <ortho-progress-bar ref="progressDialog"><v-btn @click="startProcess">Iniciar Processo</v-btn></ortho-progress-bar>
    <v-dialog v-if="hasImages" v-model="dialogVisible">
        <v-card>
            <v-card-title>Mapas</v-card-title>
            <v-card-text>
                <v-row>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XY Height Heatmap</v-card-title>
                        <img :src="xyHeatmap" alt="XY Heatmap" v-if="xyHeatmap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XZ Height Heatmap</v-card-title>
                        <img :src="xzHeatmap" alt="XZ Heatmap" v-if="xzHeatmap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>YZ Height Heatmap</v-card-title>
                        <img :src="yzHeatmap" alt="YZ Heatmap" v-if="yzHeatmap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XY Density Heatmap</v-card-title>
                        <img :src="xyDensitymap" alt="XY Densitymap" v-if="xyDensitymap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XZ Density Heatmap</v-card-title>
                        <img :src="xzDensitymap" alt="XZ Densitymap" v-if="xzDensitymap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>YZ Density Heatmap</v-card-title>
                        <img :src="yzDensitymap" alt="YZ Densitymap" v-if="yzDensitymap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XY Curvature Heatmap</v-card-title>
                        <img :src="xyCurvaturemap" alt="XY Curvaturemap" v-if="xyCurvaturemap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>XZ Curvature Heatmap</v-card-title>
                        <img :src="xzCurvaturemap" alt="XZ Curvaturemap" v-if="xzCurvaturemap">
                    </v-card>
                    <v-card class="ma-2 pa-2">
                        <v-card-title>YZ Curvature Heatmap</v-card-title>
                        <img :src="yzCurvaturemap" alt="YZ Curvaturemap" v-if="yzCurvaturemap">
                    </v-card>
                </v-row>
            </v-card-text></v-card>
    </v-dialog>

    <!-- Diálogo de ajuste -->
    <v-dialog v-model="dialogAjuste" max-width="600">
        <v-card>
            <v-card-title class="text-h6">{{ $t("ajustTimeTitle") }}</v-card-title>
            <v-card-text>
                <div class="ajuste-container">
                    <v-btn @click="ajustarMeses(-12)">
                        <v-icon>mdi-minus-circle-outline</v-icon> 12 {{ $t("months") }}
                    </v-btn>

                    <v-btn @click="ajustarMeses(-1)">
                        <v-icon>mdi-minus-circle-outline</v-icon> 1 {{ $t("month") }}
                    </v-btn>

                    <div class="tempo-central">
                        {{ tempoTratamento }} {{ $t("months") }}
                    </div>

                    <v-btn @click="ajustarMeses(1)">
                        <v-icon>mdi-plus-circle-outline</v-icon> 1 {{ $t("month") }}
                    </v-btn>

                    <v-btn @click="ajustarMeses(12)">
                        <v-icon>mdi-plus-circle-outline</v-icon> 12 {{ $t("months") }}
                    </v-btn>
                </div>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn @click="dialogAjuste = false" text>{{ $t("toothDetails.cancel") }}</v-btn>
                <v-btn @click="confirmarTempo" color="primary">{{ $t("toothDetails.confirm") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


    <!-- Diálogo para exibir a lista de arquivos -->
    <v-dialog v-model="showFileDialog">
        <v-card>
            <v-card-title>Base de Modelos</v-card-title>
            <v-card-text>
                <v-row>
                    <!-- Itera sobre os arquivos recebidos da API -->
                    <v-col cols="12" sm="4" v-for="file in fileList" :key="file.id" class="d-flex">
                        <!-- Adiciona fill-height para garantir que todos os cards tenham a mesma altura -->
                        <v-card class="d-flex flex-column justify-space-between w-100" color="blue-grey-lighten-5">
                            <v-card-title>
                                {{ file.name }}
                                <v-chip variant="flat" class="float-right"
                                    :color="file.borderInfoId ? 'lime-accent-4' : 'blue-grey-lighten-1'">
                                    {{ file.id }}
                                </v-chip>
                            </v-card-title>
                            <v-card-subtitle>{{ file.fileName }} ({{ formatFileSize(file.fileSize) }})</v-card-subtitle>

                            <v-card-actions>
                                <!-- Botão para carregar arquivo -->
                                <v-btn icon @click="loadFile(file)" size="small">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>

                                <!-- Botão para atualizar arquivo -->
                                <v-btn icon @click="updateFile(file)" size="small">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>

                                <!-- Botão para remover arquivo dentalMap -->
                                <v-btn icon @click="deleteFile(file)" size="small">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>

                                <!-- Botão para remover arquivo STL -->
                                <v-btn icon @click="deleteFile(file, true)" size="small" color="red">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="showFileDialog = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showTrainingDialog" max-width="800px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">MaxIA - Identificação de Borda</span>
                <v-switch class="float-right" color="success" v-model="reTraining"
                    label="Treinar Novamente ao Finalizar"></v-switch>
            </v-card-title>

            <v-card-text>
                <v-row>
                    <!-- Mensagem de Status -->
                    <v-alert v-if="statusMessage" :type="infoStatusMessage" dismissible class="my-2">
                        {{ statusMessage }}
                    </v-alert>
                </v-row>

                <!-- Seleção de Conjunto -->
                <v-row>
                    <v-col cols="12">
                        <v-select v-model="selectedSet" :items="updatedSets" @update:modelValue="handleSetSelection"
                            label="Selecione o Conjunto de Treinamento e Modelo" outlined></v-select>
                    </v-col>
                </v-row>

                <v-row class="justify-space-evenly">
                    <!-- Botões de Ação -->
                    <v-btn prepend-icon="mdi-table-plus" class="my-2 btn-nav" stacked @click="accumulateTrainingData">
                        Acumular Dados de Treino
                    </v-btn>

                    <v-btn prepend-icon="mdi-table-sync" class="my-2 btn-nav" stacked
                        @click="saveAccumulateTrainingData">
                        Salvar Dados de Treino
                    </v-btn>

                    <!-- Novo Botão para Carregar Dados de Treino e Modelo com base no conjunto selecionado -->
                    <v-btn color="warning" prepend-icon="mdi-table-arrow-down" class="my-2 btn-nav" stacked
                        @click="loadSelectedSetData">
                        Carregar Conjunto Selecionado
                    </v-btn>

                    <v-btn color="success" prepend-icon="mdi-table-network" class="my-2 btn-nav" stacked
                        @click="trainModelWithData">
                        Treinar Modelo
                    </v-btn>

                    <v-btn color="info" prepend-icon="mdi-cog-play" class="my-2 btn-nav" stacked
                        @click="applyModelToMesh">
                        Aplicar IA no Modelo
                    </v-btn>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-card outlined>
                            <v-card-title class="text-h6">Métricas de Treinamento por Classe</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <!-- Iterar sobre cada classe e exibir suas métricas em um v-card separado -->
                                    <v-col v-for="(metrics, index) in trainingMetrics" :key="index" cols="6">
                                        <v-card outlined>
                                            <v-card-title class="text-h6">Classe {{ metrics.classIndex }}</v-card-title>
                                            <v-card-text>
                                                <p><strong>Época:</strong> {{ metrics.epoch }} / {{ metrics.totalEpochs
                                                }}</p>
                                                <p><strong>Loss:</strong> {{ ((metrics.loss ?? 0) * 100).toFixed(2) }}%
                                                </p>
                                                <p><strong>Accuracy:</strong> {{ ((metrics.accuracy ?? 0) *
                                                    100).toFixed(2) }}%</p>
                                                <p><strong>Precisão:</strong> {{ ((metrics.precision ?? 0) *
                                                    100).toFixed(2) }}%</p>
                                                <p><strong>Revocação:</strong> {{ ((metrics.recall ?? 0) *
                                                    100).toFixed(2) }}%</p>
                                                <p><strong>F1-Score:</strong> {{ ((metrics.f1Score ?? 0) *
                                                    100).toFixed(2) }}%</p>
                                                <p><strong>Tempo:</strong> {{ (metrics.epochTime ?? 0).toFixed(2) }} seg
                                                </p>
                                                <p><strong>Tempo Médio:</strong> {{ (metrics.averageEpochTime ??
                                                    0).toFixed(2) }} seg</p>
                                                <p><strong>Tempo Estimado:</strong> {{ (metrics.estimatedRemainingTime
                                                    ?? 0).toFixed(2) }} seg</p>
                                                <p><strong>Data Estimada:</strong> {{ (metrics.estimatedEndDate) }}</p>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="showTrainingDialog = false">
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <div v-if="currentContext == 'video'">
        <div v-if="selectedToothInfo" class="hud">
            <div class="hud-item">
                <span class="icon">🦷</span>
                <span class="value">{{ $t('hud.tooth') }}: {{ translateToothNameToNotation(selectedToothInfo.name)
                    }}</span>
            </div>
            <div class="hud-item">
                <span class="icon">📍</span>
                <span class="value">{{ $t('hud.position') }}: {{selectedToothInfo.position.map(n =>
                    Number(n).toFixed(2)).join(", ")}}</span>
            </div>
            <div class="hud-item">
                <span class="icon">🔄</span>
                <span class="value">{{ $t('hud.rotation') }}: {{selectedToothInfo.rotation.map(n =>
                    Number(n).toFixed(2)).join(", ")}}</span>
            </div>
            <div class="hud-item">
                <span class="icon">📏</span>
                <span class="value">{{ $t('hud.scale') }}: {{selectedToothInfo.scale.map(n =>
                    Number(n).toFixed(2)).join(", ")}}</span>
            </div>
        </div>

        <div v-else class="hud">
            <div class="cycle-control">
                <label>{{ $t('hud.cycle') }} {{ currentCycle }}/{{ totalCycles }}</label><br>
                <input type="range" v-model="currentCycle" :min="1" :max="totalCycles"
                    @input="updateSceneForCycle_(currentCycle)" />
            </div>

            <div class="adjustments-log">
                <h4>{{ $t('hud.manualAdjustments') }}</h4>
                <ul>
                    <li v-for="[key, adj] in [...manualAdjustments.entries()]" :key="key">
                        {{ adj.toothNumber }} ({{ $t('hud.cycle') }} {{ adj.cycle }})
                        <button @click="removeManualAdjustment(key)">❌</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>


</template>

<script>
import fileMethods from './methods/fileMethods';
import renderMethods from './methods/renderMethods';
// Three.js base and utilities
import * as THREE from 'three';
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';

import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from 'three-mesh-bvh';
import { ArcballControls } from "three/addons/controls/ArcballControls.js";
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';

// Three.js loaders and exporters
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js';

// eslint-disable-next-line no-unused-vars
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
// eslint-disable-next-line no-unused-vars
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
// eslint-disable-next-line no-unused-vars
import { SMAAPass } from 'three/addons/postprocessing/SMAAPass.js';

// External libraries
import Delaunator from 'delaunator';
import { PCA } from 'ml-pca';


// Custom components and methods
import OrthoNavBar from '@/components/OrthoNavBar.vue';
import Ortho3dBottomBar from '@/components/Ortho3dBottomBar.vue';
import Ortho3dSideBar from '@/components/Ortho3dSideBar.vue';
import OrthoProgressBar from '@/components/OrthoProgressBar.vue';

import segmentationMethods from "@/components/methods/segmentationMethods";
import alignmentMethods from "@/components/methods/alignmentMethods";
import locationMethods from "@/components/methods/locationMethods";
import PreAlignmentMethods from "@/components/methods/PreAlignmentMethods";
import interfaceMethods from "@/components/methods/interfaceMethods";
import gumsMethods from "@/components/methods/gumsMethods";
import editor3DMethods from "@/components/methods/editor3DMethods";
import editor3DTempMethods from "@/components/methods/editor3DTempMethods";
import ThreeShapeMethods from "@/components/methods/ThreeShapeMethods.js";

//import conquerMethods from "@/components/methods/conquerMethods";
//import heatMapMethods from "@/components/methods/heatMapMethods";

//import borderMethods from './methods/borderMethods';
//import sphereHunter from './methods/sphereHunter';


import { createScenario } from '@/class/agMapBuilder';

//import { GeneticAlgorithm } from '@/class/agAlgorithm';
// eslint-disable-next-line no-unused-vars
import { NeuralNetwork } from "@/class/agNeuralNetwork";
// eslint-disable-next-line no-unused-vars
import { trainAgents, testAgents } from "@/class/agAgents";
// eslint-disable-next-line no-unused-vars
import { prepareData, createModel, trainModel, evaluateModel, testModel, testModelMesh, checkClassDistribution, splitData } from "@/class/tensorFlow"

// eslint-disable-next-line no-unused-vars
import { createHeatmap, createDensityMap, createCurvatureHeatmap } from '@/class/heatMap';

import * as tf from "@tensorflow/tfjs";

export default {
    name: 'ortho-3d-editor',
    scene: null,
    camera: null,
    controls: null,
    renderer: null,
    transformControl: null,
    composer: null,
    renderPass: null,
    fxaaPass: null,
    smoothingMeshEdges: null,
    currentMarker: null,
    borderTooth: null,
    physicsWorld: null,
    softBodies: [],
    transformAux1: null,
    softBodyHelpers: null,
    margin: 0.05,
    sphereMesh: null,
    modelTensorFlow: null,
    physicsMode: false,
    tensorFlow: [],
    components: {
        OrthoNavBar,
        Ortho3dBottomBar,
        Ortho3dSideBar,
        OrthoProgressBar
    },
    data() {
        return {
            currentView: 'YX',
            dialogAjuste: false,
            tempoTratamento: 0,
            tempoOriginal: 0,
            // sombras
            shadowUpMesh: null,
            shadowDownMesh: null,
            // preview config
            previewAngle: Math.PI / 30,
            translationFactor: 20,
            // flags de modificador
            isAltPressed: false,
            isShiftPressed: false,
            isAnimating: false,         // Estado da animação
            animationProgress: 0,       // Progresso atual da animação (0 a 1)
            animationStartTime: 0,      // Tempo de início da animação
            animationDuration: 5000,    // Duração da animação em milissegundos
            currentCycle: 0,
            totalCycles: 0, // Será definido ao gerar o plano
            manualAdjustments: new Map(),
            planoTratamento: new Map(), // plano gerado
            planoTratamentoOriginal: new Map(),
            currentlySelectedTooth: null, // Dente atualmente selecionado
            selectedToothInfo: null, // Informações do dente selecionado
            gumMorphing: {
                upper: {
                    mesh: null,
                    neighbors: [],
                    controlRings: [],
                    spatialHash: { hash: {}, cellSize: 5 } // ← Objeto com hash e cellSize
                },
                lower: {
                    mesh: null,
                    neighbors: [],
                    controlRings: [],
                    spatialHash: { hash: {}, cellSize: 5 }
                }
            },
            selectedSet: null,
            simulator: null,
            backendData: [], // Para armazenar os dados do backend
            updatedSets: [], // Para armazenar os dados combinados
            trainingMetrics: [{
                classIndex: null,
                epoch: null,
                totalEpochs: null,
                loss: null,
                accuracy: null,
                precision: null,
                recall: null,
                f1Score: null,
                epochTime: null,
                averageEpochTime: null,
                estimatedRemainingTime: null,
                estimatedEndDate: null
            }],
            globalDataStore: {
                inputs: [],
                labels: [],
            },
            reTraining: false,
            infoStatusMessage: 'info',
            showTrainingDialog: false,
            neuralNetwork: null,
            xyHeatmap: '',
            xzHeatmap: '',
            yzHeatmap: '',
            xyDensitymap: '',
            xzDensitymap: '',
            yzDensitymap: '',
            xyCurvaturemap: '',
            xzCurvaturemap: '',
            yzCurvaturemap: '',
            dialogVisible: false,
            showFileDialog: false,
            fileList: [], // Dados da API
            dataMatrix: [],
            clock: new THREE.Clock(),
            currentIndex: { row: 0, col: 0 },
            frameId: null, // Usado para animação,
            sceneUpdate: null,
            selectedTooth: null,
            showDialog: false,
            activeObject: null,
            isDragging: false,
            selectedSphere: null,
            highestOrLowestPoint: null,
            brushMesh: null,
            isMouseDown: false,
            mouse: new THREE.Vector2(),
            smoothGeometryVertices: [],
            intersectionPoints: [],
            idealArchPoints: { maxillary: [], mandibular: [] },
            idealArchStartPoints: { maxillary: [], mandibular: [] },
            dentalMap: {},
            intervalId: null,
            toothIndexCounter: 0,
            currentMode: "",
            statusMessage: null,
            iaActive: "gray",
            mouseDownPosition: null,
            lastMousePosition: null,
            activeDentalArch: null,
            octree: null,
            voxelGrid: null,
            voxelSize: { x: 2, y: 1, z: 2 },
            activeArchMoveType: 'fullArch',
            miniGun: { active: false, neighbor: 5, variation: 30, object: null, point: null, angleBetween: -1, curvature: 2 },
            bottomBarItems_video: [
                { text: this.$t('showHideUpperJaw'), icon: 'mdi-chevron-up-circle', action: 'toggleUpperJaw' },
                { text: this.$t('showHideLowerJaw'), icon: 'mdi-chevron-down-circle', action: 'toggleLowerJaw' },
                { text: this.$t('showHideLowerJaw'), icon: 'mdi-arrow-up-down-bold', action: 'toggleJaw' },
                { text: this.$t('playAnimation'), icon: 'mdi-play', action: 'playAnimation' },
                { text: this.$t('pauseAnimation'), icon: 'mdi-pause', action: 'pauseAnimation' },
                { text: this.$t('resetAnimation'), icon: 'mdi-restart', action: 'resetAnimation' },
                { text: this.$t('turnOffAmbientLight'), icon: 'mdi-white-balance-sunny', action: 'toggleLight' },
                { text: this.$t('turnOffDirectionalLight1'), icon: 'mdi-lightbulb', action: 'toggleLightDir1' },
                { text: this.$t('turnOffDirectionalLight2'), icon: 'mdi-lightbulb', action: 'toggleLightDir2' },
                { text: this.$t('createPlan'), icon: 'mdi-abacus', action: 'createPlan' },
                { text: this.$t('alignModel'), icon: 'mdi-rotate-3d', action: 'alignModel' },
                { text: this.$t('plotPivotLines'), icon: 'mdi-axis-arrow', action: 'plotPivotLines' },
            ],
            bottomBarItems_editor: [
                { text: this.$t('toggleVisibility'), icon: 'mdi-eye-outline', action: 'toggleObjectVisibility' },
                { text: this.$t('assignMotionController'), icon: 'mdi-cube-outline', action: 'toggleBoxHelper' },
                { text: this.$t('showHideUpperJaw'), icon: 'mdi-chevron-up-circle', action: 'toggleUpperJaw' },
                { text: this.$t('showHideLowerJaw'), icon: 'mdi-chevron-down-circle', action: 'toggleLowerJaw' },
                { text: this.$t('activateTranslation'), icon: 'mdi-axis-arrow', action: 'controlTranslate' },
                { text: this.$t('activateRotation'), icon: 'mdi-rotate-3d', action: 'controlRotate' },
                { text: this.$t('turnOffAmbientLight'), icon: 'mdi-white-balance-sunny', action: 'toggleLight' },
                { text: this.$t('turnOffDirectionalLight1'), icon: 'mdi-lightbulb', action: 'toggleLightDir1' },
                { text: this.$t('turnOffDirectionalLight2'), icon: 'mdi-lightbulb', action: 'toggleLightDir2' },
                { text: this.$t('applyCutAbovePlane'), icon: 'mdi-arrow-up-bold-box-outline', action: 'applyCutAbove' },
                { text: this.$t('applyCutBelowPlane'), icon: 'mdi-arrow-down-bold-box-outline', action: 'applyCutBelow' },
                { text: this.$t('activateContourMarking'), icon: 'mdi-vector-polygon', action: 'toggleContourMarking' },
                { text: this.$t('clearContours'), icon: 'mdi-delete', action: 'clearContourPoints' },
                { text: this.$t('frontView'), icon: 'mdi-axis-z-arrow', action: 'viewFront' },
                { text: this.$t('leftView'), icon: 'mdi-axis-x-arrow', action: 'viewLeft' },
                { text: this.$t('topView'), icon: 'mdi-axis-y-arrow', action: 'viewBottom' },
                { text: this.$t('toggleGumsVisibility'), icon: 'mdi-tooth', action: 'toggleGums' },
                { text: this.$t('toggleTeethVisibility'), icon: 'mdi-tooth-outline', action: 'toggleTeeth' },
                { text: this.$t('clearTasks'), icon: 'mdi-broom', action: 'clearTasks' },
                { text: this.$t('applyChanges'), icon: 'mdi-update', action: 'applyChanges' },
                { text: 'saveBorderInfo', icon: 'mdi-content-save', action: 'saveBorderInfo' },
                { text: 'loadBorderInfo', icon: 'mdi-download', action: 'loadBorderInfo' }
            ]
            ,
            sideBarItems: [
                { text: 'occlusionPlan', icon: 'mdi-circle-outline', action: 'creatingOcclusionPlan', loading: false, isFile: false },
                { text: 'cuttingPlane', icon: 'mdi-scissors-cutting', action: 'cutModel', loading: false, isFile: false },
                { text: 'idealDentalArch', icon: 'mdi-vector-curve', action: 'creatingDentalArch', loading: false, isFile: false },
                { text: 'archMoveType', icon: 'mdi-vector-curve', action: 'toggleArchMoveType', loading: false, isFile: false },
                { text: 'dynamicGum', icon: 'mdi-tooth', action: 'dynamicGum', loading: false, isFile: false },
                { text: 'dentalArch', icon: 'mdi-vector-curve', action: 'showDentalArch', loading: false, isFile: false },
                { text: 'smoothBorder', icon: 'mdi-blur', action: 'startSES', loading: false, isFile: false },
                { text: 'saveActiveObject', icon: 'mdi-download', action: 'saveActiveObject', loading: false, isFile: false },
                { text: 'extractToothBorder', icon: 'mdi-pencil', action: 'extractToothBorder', loading: false, isFile: false },
                { text: 'loadSegmentation', icon: 'mdi-folder-open', action: 'loadSegmentation', loading: false, isFile: false },
                { text: 'saveSegmentation', icon: 'mdi-content-save', action: 'saveSegmentation', loading: false, isFile: false },
                { text: 'createDentalMesh', icon: 'mdi-creation', action: 'createDentalMesh', loading: false, isFile: false },
                { text: 'loadModel', icon: 'mdi-folder-open', action: 'load3SzFile', loading: false, isFile: true }
            ],
        };
    },
    methods: {
        ...fileMethods.methods,
        ...renderMethods.methods,
        ...segmentationMethods.methods,
        ...alignmentMethods.methods,
        ...locationMethods.methods,
        ...PreAlignmentMethods.methods,
        ...gumsMethods.methods,
        ...interfaceMethods.methods,
        ...editor3DMethods.methods,
        ...editor3DTempMethods.methods,
        ...ThreeShapeMethods.methods,

        initializeSES() {
            // Verificar se existe um activeObject
            if (!this.activeObject) {
                console.error("No active object to initialize SES.");
                return;
            }

            // Encontrar o mesh com userData.objectType igual a "gums" dentro do activeObject
            const gumsMesh = this.activeObject.children.find(
                (child) => child.userData.objectType === "gums"
            );
            if (!gumsMesh) {
                console.error("No gums mesh found in the active object.");
                return;
            }

            // Verificar se o gumsMesh tem geometria
            if (!gumsMesh.geometry) {
                console.error("No geometry found in the gums mesh.");
                return;
            }

            const modelType = this.activeObject.userData.modelType;
            const otherMeshes = this.scene.children.filter(
                (child) =>
                    child !== this.activeObject && // Certifique-se de não incluir o próprio activeObject
                    child.userData.modelType === modelType && // Mesmo modelType
                    child.geometry // Verifique se o mesh tem geometria
            );

            // Criar a geometria das arestas a partir da geometria do gumsMesh
            const edges = new THREE.EdgesGeometry(otherMeshes[0].geometry, 90);

            // Material para as linhas das arestas
            const edgeMaterial = new THREE.LineBasicMaterial({
                color: 0x0000ff,
                linewidth: 2,
            });

            let vertices = [];

            for (let i = 0; i < edges.attributes.position.count; i++) {
                const x = edges.attributes.position.getX(i);
                const y = edges.attributes.position.getY(i);
                const z = edges.attributes.position.getZ(i);
                vertices.push(new THREE.Vector3(x, y, z));
            }

            // Filtrar outliers
            vertices = this.filterOutliers(vertices);

            // Atualizar o BufferAttribute com os vértices filtrados
            this.updatePositionAttribute(edges, vertices);

            // Criar um objeto de linha com a geometria das arestas e o material
            const edgeLines = new THREE.LineSegments(edges, edgeMaterial);

            this.smoothingMeshEdges = edgeLines.geometry;

            // Adicionar as linhas de aresta à cena
            //this.scene.add(edgeLines);

            // Determina o tipo de arcada baseado no userData.modelType do objeto ativo
            const isUpperArc = this.activeObject.userData.modelType === "maxillary";

            let referencePoint = isUpperArc ? -Infinity : Infinity;
            const positionAttribute = this.smoothingMeshEdges.attributes.position;

            // Encontra o ponto mais alto (para maxillary) ou mais baixo (para mandibular)
            for (let i = 0; i < positionAttribute.count; i++) {
                const y = positionAttribute.getY(i);
                referencePoint = isUpperArc
                    ? Math.max(y, referencePoint)
                    : Math.min(y, referencePoint);
            }

            // Armazena o ponto mais alto/mais baixo encontrado
            this.highestOrLowestPoint = referencePoint;

            return this.smoothEdgeContours();
        },
        initializeSES_() {
            if (!this.activeObject || !this.activeObject.geometry) {
                console.error("No active object with geometry to initialize SES.");
                return;
            }

            //this.$store.dispatch('editor3D/startEdgeSmoothing', 1);
            //this.updateSESCursor();

            const edges = new THREE.EdgesGeometry(this.activeObject.geometry, 90);

            // Material para as linhas das arestas
            const edgeMaterial = new THREE.LineBasicMaterial({
                color: 0xffffff,
                linewidth: 2,
            });

            let vertices = [];

            for (let i = 0; i < edges.attributes.position.count; i++) {
                const x = edges.attributes.position.getX(i);
                const y = edges.attributes.position.getY(i);
                const z = edges.attributes.position.getZ(i);
                vertices.push(new THREE.Vector3(x, y, z));
            }

            // Filtrar outliers
            vertices = this.filterOutliers(vertices);

            // Atualizar o BufferAttribute com os vértices filtrados
            this.updatePositionAttribute(edges, vertices);

            // Criar um objeto de linha com a geometria das arestas e o material
            const edgeLines = new THREE.LineSegments(edges, edgeMaterial);

            this.smoothingMeshEdges = edgeLines.geometry;

            // Adicionar as linhas de aresta à cena
            // this.scene.add(edgeLines);

            // Determina o tipo de arcada baseado no userData.modelType do objeto ativo
            const isUpperArc = this.activeObject.userData.modelType === "maxillary";

            let referencePoint = isUpperArc ? -Infinity : Infinity;
            const positionAttribute = this.smoothingMeshEdges.attributes.position;

            // Encontra o ponto mais alto (para maxillary) ou mais baixo (para mandibular)
            for (let i = 0; i < positionAttribute.count; i++) {
                const y = positionAttribute.getY(i);
                referencePoint = isUpperArc
                    ? Math.max(y, referencePoint)
                    : Math.min(y, referencePoint);
            }

            // Armazena o ponto mais alto/mais baixo encontrado
            this.highestOrLowestPoint = referencePoint;

            return this.smoothEdgeContours();
        },
        filterOutliers(vertices) {
            const k = 4; // Número de vizinhos mais próximos a considerar
            const thresholdFactor = 5; // Fator multiplicativo para a distância média

            // Calcular a distância média entre os pontos e seus k vizinhos mais próximos
            let distances = [];
            vertices.forEach((vertex, index) => {
                let dists = vertices
                    .map((v) => vertex.distanceTo(v))
                    .sort((a, b) => a - b)
                    .slice(1, k + 1);
                distances[index] = dists.reduce((a, b) => a + b, 0) / k;
            });

            let meanDistance =
                distances.reduce((a, b) => a + b, 0) / distances.length;
            let threshold = meanDistance * thresholdFactor;

            // Filtrar os pontos que têm uma distância média aos vizinhos menor que o limite
            let filteredVertices = vertices.filter(
                (vertex, index) => distances[index] < threshold
            );

            return filteredVertices;
        },
        updatePositionAttribute(geometry, vertices) {
            const positions = new Float32Array(vertices.length * 3);
            vertices.forEach((vertex, i) => {
                positions[i * 3] = vertex.x;
                positions[i * 3 + 1] = vertex.y;
                positions[i * 3 + 2] = vertex.z;
            });

            // Substituir o buffer de posição existente
            geometry.attributes.position = new THREE.BufferAttribute(positions, 3);
            geometry.attributes.position.needsUpdate = true; // Sinaliza que o buffer precisa ser atualizado
        },
        connectEdgePoints(vertices) {
            let path = [];
            let remaining = new Set(vertices.map((v) => v.toArray().toString())); // Todos os pontos como strings

            let currentPoint = vertices[0]; // Ponto inicial arbitrário
            path.push(currentPoint);
            remaining.delete(currentPoint.toArray().toString());

            while (remaining.size > 0) {
                let nextPoint = null;
                let minDistance = 5;

                remaining.forEach((vStr) => {
                    let v = new THREE.Vector3().fromArray(vStr.split(",").map(Number));
                    let distance = currentPoint.distanceTo(v);
                    if (distance < minDistance) {
                        minDistance = distance;
                        nextPoint = v;
                    }
                });

                if (nextPoint) {
                    path.push(nextPoint);
                    remaining.delete(nextPoint.toArray().toString());
                    currentPoint = nextPoint;
                } else {
                    break; // No valid next point found
                }
            }

            return path;
        },
        smoothEdgeContours() {
            if (!this.smoothingMeshEdges) {
                console.error("No edge geometry available to process.");
                return;
            }

            const vertices = [];
            const positionAttribute = this.smoothingMeshEdges.attributes.position;

            for (let i = 0; i < positionAttribute.count; i += 3) {
                const vertex = new THREE.Vector3(
                    positionAttribute.getX(i),
                    positionAttribute.getY(i),
                    positionAttribute.getZ(i)
                );
                vertices.push(vertex);
            }

            // Traça o caminho completo usando os vértices
            const orderedVertices = this.connectEdgePoints(vertices);

            // Cria a curva Catmull-Rom com os vértices ordenados e adiciona ao cenário
            const curve = new THREE.CatmullRomCurve3(
                orderedVertices,
                false,
                "catmullrom",
                0.25
            );
            const points = curve.getPoints(Math.floor(vertices.length / 2));

            // const curveGeometry = new THREE.BufferGeometry().setFromPoints(points);
            // const material = new THREE.LineBasicMaterial({ color: 0xff00ff });
            // const curveObject = new THREE.Line(curveGeometry, material);
            // this.scene.add(curveObject);
            return points;
        },
        updateSESCursor() {
            const radius = this.$store.state.editor3D.smoothingRadius;

            // Cria ou atualiza a geometria do cursor
            const cursorGeometry = new THREE.SphereGeometry(radius, 32, 32);

            // Material translúcido para o cursor
            const cursorMaterial = new THREE.MeshBasicMaterial({
                color: 0x00ff00, // Verde, por exemplo
                transparent: true,
                opacity: 0.5,
            });

            if (this.brushMesh) {
                // Atualiza a geometria do cursor existente
                this.brushMesh.geometry.dispose(); // Descarta a geometria antiga
                this.brushMesh.geometry = cursorGeometry;
                this.brushMesh.material = cursorMaterial;
                this.brushMesh.visible = true;
            } else {
                // Cria um novo cursor e o adiciona à cena
                const cursorMesh = new THREE.Mesh(cursorGeometry, cursorMaterial);
                cursorMesh.userData.name = "Brush";
                this.scene.add(cursorMesh);
                this.brushMesh = cursorMesh;
            }

            // Certifique-se de que a cena seja atualizada
            this.renderer.render(this.scene, this.camera);
        },
        commitTransform() {
            this.statusMessage = "Transformação Aplicada";
            const object = this.activeObject;

            if (!object || !object.geometry) {
                console.error("Não foi fornecido um objeto ou geometria válida.");
                return;
            }

            // Aplica a matriz de transformação à geometria do objeto
            if (object.geometry.isBufferGeometry) {
                // Para BufferGeometry, aplicar a matriz diretamente
                object.geometry.applyMatrix4(object.matrix);
                object.geometry.attributes.position.needsUpdate = true;
                if (object.geometry.attributes.normal) {
                    object.geometry.attributes.normal.needsUpdate = true;
                }
            } else if (object.geometry.isGeometry) {
                // Para THREE.Geometry (legado)
                object.geometry.applyMatrix(object.matrix);
                object.geometry.verticesNeedUpdate = true;
                object.geometry.normalsNeedUpdate = true;
            }

            // Recalcular as bounding boxes e spheres
            object.geometry.computeBoundingBox();
            object.geometry.computeBoundingSphere();
            object.updateMatrixWorld(true);

            // Resetar a matriz de transformação do objeto
            object.position.set(0, 0, 0);
            object.rotation.set(0, 0, 0);
            object.scale.set(1, 1, 1);
            object.matrix.identity(); // Reseta a matriz para a identidade
            object.matrixWorld.identity(); // Reseta a matriz do mundo para a identidade

            // Recalcular as normais para geometrias
            if (object.geometry.isBufferGeometry) {
                object.geometry.computeVertexNormals();
                object.geometry.computeBoundsTree();
                this.calculateVertexNormals(object.geometry);
                this.$store.dispatch("editor3D/updateScene", this.scene);
                this.sceneUpdate = new Date();
                this.$store.dispatch("editor3D/updateDate", this.sceneUpdate);
            }
        },
        addAxisPlanes() {
            // Define o raio dos círculos
            const circleRadius = 40;

            // Cria o material para os círculos
            const materialX = new THREE.MeshBasicMaterial({
                color: 0xff0000,
                side: THREE.DoubleSide,
                transparent: true,
                opacity: 0.5,
            });
            const materialY = new THREE.MeshBasicMaterial({
                color: 0x00ff00,
                side: THREE.DoubleSide,
                transparent: true,
                opacity: 0.5,
            });
            const materialZ = new THREE.MeshBasicMaterial({
                color: 0x0000ff,
                side: THREE.DoubleSide,
                transparent: true,
                opacity: 0.5,
            });

            // Cria três geometrias circulares
            const circleGeometry = new THREE.CircleGeometry(circleRadius, 32);

            // Cria um grupo para conter os três círculos
            const axisPlanesGroup = new THREE.Group();

            // Cria e adiciona os círculos ao grupo
            const circleX = new THREE.Mesh(circleGeometry, materialX);
            circleX.rotation.y = Math.PI / 2;
            axisPlanesGroup.add(circleX);

            const circleY = new THREE.Mesh(circleGeometry, materialY);
            circleY.rotation.x = Math.PI / 2;
            axisPlanesGroup.add(circleY);

            const circleZ = new THREE.Mesh(circleGeometry, materialZ);
            axisPlanesGroup.add(circleZ);

            // Move o grupo para o centro da cena
            axisPlanesGroup.position.set(0, 0, 0);

            // Adiciona o grupo à cena
            this.scene.add(axisPlanesGroup);
        },
        rotateGeometry(geometry, angle) {
            // Aplicar a rotação de -90 graus em torno do eixo X a todos os vértices
            const rotationMatrix = new THREE.Matrix4();
            rotationMatrix.makeRotationX(angle);

            geometry.applyMatrix4(rotationMatrix);

            // Rotacionar as normais para que a iluminação seja calculada corretamente
            geometry.computeVertexNormals();
        },
        alignModelUsingPCA(geometry) {
            // Verifica se a geometria possui o atributo de posição
            if (!geometry.attributes.position) {
                console.error("A geometria fornecida não tem atributos de posição.");
                return;
            }

            // Extrair os vértices da geometria
            const positionAttribute = geometry.attributes.position;
            const vertices = [];
            for (let i = 0; i < positionAttribute.count; i++) {
                vertices.push([
                    positionAttribute.getX(i),
                    positionAttribute.getY(i),
                    positionAttribute.getZ(i),
                ]);
            }

            // Aplicar PCA aos pontos
            const pca = new PCA(vertices);
            const eigenVectors = pca.getEigenvectors();
            // Reordenar os eigenvectors se necessário
            const alignX = new THREE.Vector3(...eigenVectors.data[1]); // Segundo eigenvector alinha com X
            const alignY = new THREE.Vector3(...eigenVectors.data[2]); // Terceiro eigenvector alinha com Y
            const alignZ = new THREE.Vector3(...eigenVectors.data[0]); // Primeiro eigenvector alinha com Z

            // Criar uma matriz de rotação usando os eigenvectors
            const rotationMatrix = new THREE.Matrix4().set(
                alignX.x,
                alignY.x,
                alignZ.x,
                0,
                alignX.y,
                alignY.y,
                alignZ.y,
                0,
                alignX.z,
                alignY.z,
                alignZ.z,
                0,
                0,
                0,
                0,
                1
            );

            // Converter a matriz de rotação para ângulos de Euler
            const currentEuler = new THREE.Euler().setFromRotationMatrix(
                rotationMatrix,
                "XYZ"
            );
            console.log(
                `Rotation Angles: X=${(currentEuler.x * 180) / Math.PI}°, Y=${(currentEuler.y * 180) / Math.PI
                }°, Z=${(currentEuler.z * 180) / Math.PI}°`
            );

            // Criar um novo objeto Euler com ângulos negativos
            const inverseEuler = new THREE.Euler(
                -currentEuler.x,
                -currentEuler.y,
                -currentEuler.z,
                "XYZ"
            );

            // Criar uma matriz de rotação a partir do Euler inverso
            const inverseRotationMatrix = new THREE.Matrix4().makeRotationFromEuler(
                inverseEuler
            );

            // Aplicar a matriz de rotação à geometria
            geometry.applyMatrix4(inverseRotationMatrix);
        },
        addLinesBetweenPoints(
            points,
            parent,
            isClosed = true,
            radius = 0.1,
            color = 0x404040
        ) {
            // Certifique-se de que há pelo menos dois pontos para formar uma linha
            if (points.length > 1) {
                const curve = new THREE.CatmullRomCurve3(
                    points,
                    isClosed,
                    "catmullrom",
                    0.5
                );

                const tubeGeometry = new THREE.TubeGeometry(
                    curve,
                    24 * points.length,
                    radius,
                    8,
                    isClosed
                ); // Ajuste os parâmetros conforme necessário
                const tubeMaterial = new THREE.MeshBasicMaterial({ color: color });
                const tubeMesh = new THREE.Mesh(tubeGeometry, tubeMaterial);
                parent.add(tubeMesh);
            }
        },
        initThree() {
            // Cria a cena
            this.scene = new THREE.Scene();

            THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
            THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
            THREE.Mesh.prototype.raycast = acceleratedRaycast;

            // Cria a câmera
            const width = this.$refs.threejsContainer.clientWidth;
            const height = this.$refs.threejsContainer.clientHeight;
            this.camera = new THREE.PerspectiveCamera(5, width / height, 1, 5000);
            this.camera.position.x = 0;
            this.camera.position.y = 300;
            this.camera.position.z = 500;

            // Cria o renderer e anexa o canvas ao DOM
            this.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: true,
                precision: 'highp'
            });
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
            this.renderer.setSize(width, height);
            //this.renderer.shadowMap.enabled = true;
            //this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            this.renderer.setClearColor(this.backgroundColor);
            this.$refs.threejsContainer.appendChild(this.renderer.domElement);

            // Configurar PMREMGenerator para iluminação ambiental procedural
            const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
            pmremGenerator.compileEquirectangularShader();

            // Criar um ambiente procedural (cor do céu azul)
            //this.scene.environment = pmremGenerator.fromScene(new THREE.Scene(), 0.04).texture;

            this.controls = new ArcballControls(this.camera, this.renderer.domElement);

            // Configura os limites de zoom
            this.controls.minDistance = 50;
            this.controls.maxDistance = 2000;

            // Ativa o amortecimento para uma experiência de zoom mais suave (opcional)
            this.controls.enableDamping = false;
            this.controls.dampingFactor = 0.25;
            this.controls.enableZoom = true;
            this.controls.enablePan = true;
            this.controls.enableAnimations = false;
            this.controls.rotateSpeed = 0.5
            this.controls.wMax = 0;

            this.controls.zoomSpeed = 0.2;

            this.controls.setMouseAction("ROTATE", 2, null);
            this.controls.setMouseAction("PAN", 1, null);
            this.controls.setMouseAction("FOV", 0, "CTRL");
            this.controls.unsetMouseAction(0, null);
            //this.controls.unsetMouseAction(2, null);

            this.controls.update();

            // Luz ambiente
            const ambientLight = new THREE.AmbientLight(0xffffff, 1);
            ambientLight.userData = { light: "ambient", name: this.$t('ambientLight'), hide: true }
            ambientLight.visible = true;
            this.scene.add(ambientLight);

            // Luz direcional principal
            const directionalLight1 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight1.position.set(0, 1500, 1500); // Posicionada para iluminar de cima e da frente
            directionalLight1.userData = { light: "directional1", name: this.$t('directionalLight'), hide: true }
            directionalLight1.visible = true;
            this.scene.add(directionalLight1);

            // Luz direcional secundária para iluminar o lado oposto do modelo
            const directionalLight2 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight2.position.set(0, -1500, -1500); // Posicionada para iluminar de baixo e de trás
            directionalLight2.userData = { light: "directional2", name: this.$t('directionalLight'), hide: true }
            directionalLight2.visible = true;
            this.scene.add(directionalLight2);


            // Luz direcional principal
            const directionalLight3 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight3.position.set(1500, 0, 0); // Posicionada para iluminar de cima e da frente
            directionalLight3.userData = { light: "directional3", name: this.$t('directionalLight'), hide: true }
            this.scene.add(directionalLight3);


            // Luz direcional secundária para iluminar o lado oposto do modelo
            const directionalLight4 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight4.position.set(-1500, 0, 0); // Posicionada para iluminar de baixo e de trás
            directionalLight4.userData = { light: "directional4", name: this.$t('directionalLight'), hide: true }
            this.scene.add(directionalLight4);

            // Luz direcional principal
            const directionalLight5 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight5.position.set(0, 1500, 0); // Posicionada para iluminar de cima
            directionalLight5.userData = { light: "directional5", name: this.$t('directionalLight'), hide: true }
            this.scene.add(directionalLight5);


            // Luz direcional secundária para iluminar o lado oposto do modelo
            const directionalLight6 = new THREE.DirectionalLight(0xffffff, 1);
            directionalLight6.position.set(0, -1500, 0); // Posicionada para iluminar de baixo
            directionalLight6.userData = { light: "directional6", name: this.$t('directionalLight'), hide: true }
            this.scene.add(directionalLight6);


            this.transformControl = new TransformControls(this.camera, this.renderer.domElement);
            this.transformControl.setMode("translate");
            this.transformControl.userData = { name: this.$t('transformControl'), hide: true }

            // Removendo a child com isTransformControlsPlane = true
            for (let i = this.transformControl.children.length - 1; i >= 0; i--) {
                const child = this.transformControl.children[i];
                if (child.isTransformControlsPlane) {
                    //this.transformControl.remove(child);
                }
            }


            // Removendo a child do rotate
            // for (let i = this.transformControl.children[0].gizmo.rotate.children.length - 1; i >= 0; i--) {
            //     const child = this.transformControl.children[0].gizmo.rotate.children[i];
            //     if (child.name !== 'E') {
            //         this.transformControl.children[0].gizmo.rotate.remove(child);
            //     }
            // }


            this.transformControl.traverse(function (child) {
                if (child.material) {
                    child.material.transparent = true;
                    child.material.opacity = 0.20; // Ajuste o valor da opacidade conforme necessário
                    child.material.needsUpdate = true;
                }
            });

            this.controls.addEventListener('change', () => {
                // só atualiza sombras se estivermos editando um dente
                if (this.currentlySelectedTooth) {
                    this.updateToothShadows();
                }
            });


            // Evento dragging-changed para ajustar a visibilidade e opacidade durante o arraste
            this.transformControl.addEventListener('dragging-changed', event => {
                if (event.value) {
                    this.transformControl.children.forEach(child => {
                        if (child.type === 'TransformControlsGizmo') {
                            child.visible = true;
                        }
                    });
                } else {
                    if (this.transformControl.object.userData.objectType && this.transformControl.object.userData.objectType === 'tooth') {
                        const tooth = this.transformControl.object.userData.toothNumber;
                        this.dentalMap[tooth].centerOfMass = this.transformControl.object.position.clone();
                        //this.closeGapsBetweenTeethAndGum()
                    }
                    this.transformControl.children.forEach(child => {
                        if (child.type === 'TransformControlsGizmo') {
                            child.visible = true;
                        }
                    });
                }
            });

            this.scene.add(this.transformControl);


            // Adicionar o ouvinte de evento ao TransformControls
            // this.transformControl.addEventListener('change', (event) => {
            //     if (this.transformControl.object.userData.objectType && this.transformControl.object.userData.objectType === 'tooth') {
            //         this.analyzeAdjacentTeeth(this.transformControl.object.userData.toothNumber)
            //     }
            // });

            //this.composer = new EffectComposer(this.renderer);

            // Render Pass
            //this.renderPass = new RenderPass(this.scene, this.camera);
            //this.composer.addPass(this.renderPass);

            // this.fxaaPass = new SMAAPass(width * this.renderer.getPixelRatio(), height * this.renderer.getPixelRatio());
            // this.composer.addPass(this.fxaaPass);

            this.animate();

        },
        saveImageAsync(imageURL, filename) {
            return new Promise((resolve) => {
                const link = document.createElement("a");
                link.href = imageURL;
                link.download = filename;
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve();
            });
        },
        saveImage(imageURL, filename) {
            // Criar um link temporário para baixar o arquivo
            const link = document.createElement("a");
            link.href = imageURL;
            link.download = filename;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async loadSelectedSetData() {
            if (this.selectedSet === null) {
                this.statusMessage = 'Por favor, selecione um conjunto antes de carregar.';
                this.infoStatusMessage = 'error';
                return;
            }

            try {
                // Carrega os dados de treino (BIGDATA_X) com base no conjunto selecionado
                await this.loadAccumulateTrainingData(this.selectedSet)

                // Carrega o modelo treinado (TENSOR_X) com base no conjunto selecionado
                this.initializeModel(this.selectedSet)

                this.statusMessage = `Conjunto ${this.selectedSet} carregado com sucesso!`;
                this.infoStatusMessage = 'success';
                if (this.reTraining) {
                    setTimeout(() => {
                        this.trainModelWithData();
                    }, 2000); // 2000 milissegundos = 2 segundos
                }
            } catch (error) {
                this.statusMessage = 'Erro ao carregar o conjunto.';
                this.infoStatusMessage = 'error';
            }
        },
        async saveTensorModel(model, metadata = {}, id = '') {

            // Função para converter ArrayBuffer para Base64
            function arrayBufferToBase64(buffer) {
                let binary = '';
                let bytes = new Uint8Array(buffer);
                let len = bytes.byteLength;
                for (let i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            }
            try {
                // Salva o modelo em um objeto JSON (formatado como JSON).
                const modelArtifacts = await model.save(tf.io.withSaveHandler(async (artifacts) => artifacts));

                // Convertendo o ArrayBuffer weightData para Base64
                const modelJsonWithMetadata = {
                    modelTopology: modelArtifacts.modelTopology,
                    weightData: modelArtifacts.weightData ? arrayBufferToBase64(modelArtifacts.weightData) : null,
                    weightSpecs: modelArtifacts.weightSpecs,
                    metadata: metadata
                };

                // Salva a estrutura e os pesos do modelo no backend
                const result = await this.dbSaveJsonData(`TENSOR_${id}`, modelJsonWithMetadata, -1);
                if (result) {
                    this.infoStatusMessage = 'success';
                    this.statusMessage = "Modelo salvo com sucesso no backend.";
                } else {
                    this.infoStatusMessage = 'error'
                    this.statusMessage = "Erro ao salvar modelo.";
                }

            } catch (error) {
                this.infoStatusMessage = 'error';
                this.statusMessage = "Erro ao salvar o modelo.";
            }

            await this.dbLoadTrainingCounter();

            if (this.reTraining) {
                setTimeout(() => {
                    //this.selectedSet = (this.selectedSet < 4) ? this.selectedSet + 1 : 2;
                    this.loadSelectedSetData();
                }, 2000); // 2000 milissegundos = 2 segundos
            }


        },
        async loadAllModels() {
            this.tensorFlow = []
            for (let i = 1; i <= 8; i++) {
                const model = await this.loadTensorModel(i);
                if (model) {
                    model.compile({
                        optimizer: tf.train.adam(0.01),
                        loss: "categoricalCrossentropy",
                        metrics: ["accuracy"]
                    });
                }
            }
            this.statusMessage = 'IA Multipla Carregada com Sucesso'
        },
        async loadTensorModel(id = '') {
            // Função para converter Base64 para ArrayBuffer
            function base64ToArrayBuffer(base64) {
                let binary_string = window.atob(base64);
                let len = binary_string.length;
                let bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            }
            try {
                // Carrega o JSON do modelo a partir do backend
                const modelJson = await this.dbLoadJsonData(`TENSOR_${id}`, -1);

                if (modelJson) {
                    // Decodifica weightData de Base64 para ArrayBuffer
                    const modelArtifacts = {
                        modelTopology: modelJson.modelTopology,
                        weightData: modelJson.weightData ? base64ToArrayBuffer(modelJson.weightData) : null,
                        weightSpecs: modelJson.weightSpecs
                    };

                    const model = await tf.loadLayersModel(tf.io.fromMemory(modelArtifacts));
                    this.tensorFlow.push({ id, model }); // Adiciona o modelo carregado no array tensorFlow
                    this.infoStatusMessage = 'info';
                    this.statusMessage = `Modelo ${id} carregado com sucesso.`;
                    console.log(`Modelo ${id} carregado com sucesso.`)
                    return model
                } else {
                    console.error("Erro: Dados do modelo não encontrados.");
                    return null
                }
            } catch (error) {
                console.error(error);
                this.infoStatusMessage = 'warning';
                this.statusMessage = `Erro ao carregar o modelo ${id}.`;
                return null
            }
        },
        async loadAccumulateTrainingData(id = '') {
            this.infoStatusMessage = 'info';
            this.statusMessage = "Carregando dados de treino do backend...";

            // Carregar dados completos do banco de dados
            const dadosDb = await this.dbLoadJsonData(`BIGDATA_${id}`, -1);

            if (dadosDb) {
                const inputs = dadosDb.inputs;
                const labels = dadosDb.labels;

                // Organizar dados por classe
                const dataByClass = {};
                labels.forEach((label, index) => {
                    if (!dataByClass[label]) {
                        dataByClass[label] = { inputs: [], labels: [] };
                    }
                    dataByClass[label].inputs.push(inputs[index]);
                    dataByClass[label].labels.push(label);
                });

                // Encontrar o tamanho da menor classe
                const minClassSize = Math.min(...Object.values(dataByClass).map(data => data.inputs.length));

                // Extrair uma amostra balanceada para cada classe
                const sampledInputs = [];
                const sampledLabels = [];
                for (const [, data] of Object.entries(dataByClass)) {
                    const sampleIndices = Array.from({ length: data.inputs.length }, (_, i) => i)
                        .sort(() => Math.random() - 0.5) // Embaralhar
                        .slice(0, minClassSize); // Selecionar até o tamanho da menor classe

                    sampleIndices.forEach(idx => {
                        sampledInputs.push(data.inputs[idx]);
                        sampledLabels.push(data.labels[idx]);
                    });
                }

                // Concatenar amostras balanceadas ao armazenamento global
                //this.globalDataStore.inputs = this.globalDataStore.inputs.concat(sampledInputs);
                //this.globalDataStore.labels = this.globalDataStore.labels.concat(sampledLabels);
                this.globalDataStore.inputs = sampledInputs;
                this.globalDataStore.labels = sampledLabels;

                this.infoStatusMessage = 'success';
                this.statusMessage = "Dados carregados com sucesso.";
            } else {
                this.infoStatusMessage = 'error';
                this.statusMessage = "Erro ao carregar dados.";
            }
        },
        async loadAccumulateTrainingData_() {
            this.infoStatusMessage = 'info'
            this.statusMessage = "Carregando dados de treino do backend...";
            const dadosDb = await this.dbLoadJsonData('BIGDATA', -1);
            if (dadosDb) {
                const inputs = dadosDb.inputs;
                const labels = dadosDb.labels;
                this.globalDataStore.inputs = this.globalDataStore.inputs.concat(inputs);
                this.globalDataStore.labels = this.globalDataStore.labels.concat(labels);
                this.infoStatusMessage = 'success'
                this.statusMessage = "Dados carregados com sucesso.";
            } else {
                this.infoStatusMessage = 'error'
                this.statusMessage = "Erro ao carregar dados.";
            }
        },
        async saveAccumulateTrainingData() {
            this.infoStatusMessage = 'info'
            this.statusMessage = "Salvando dados de treino no backend...";
            const inputs = this.globalDataStore.inputs;
            const labels = this.globalDataStore.labels;
            const result = await this.dbSaveJsonData(`BIGDATA_${this.selectedSet}`, { inputs, labels }, -1);
            if (result) {
                this.statusMessage = "Dados salvos com sucesso.";
            } else {
                this.infoStatusMessage = 'error'
                this.statusMessage = "Erro ao salvar dados.";
            }
        },
        async accumulateTrainingData() {
            let inputs, labels
            // Obtém os dados do modelo e cenário
            this.statusMessage = "Obtendo dados para TensorFlow...";
            const dadosDb = await this.dbLoadJsonData('INPUT');
            this.infoStatusMessage = 'info'

            if (!dadosDb) {
                const spheresMap = this.analyzeSpheresBVH(this.activeObject.geometry, 0.25);
                const scenario = createScenario(this.activeObject, spheresMap);

                // Prepara os dados de treinamento
                this.statusMessage = "Preparando dados para TensorFlow...";
                ({ inputs, labels } = prepareData(scenario));
                await this.dbSaveJsonData('INPUT', { inputs, labels })
            } else {
                inputs = dadosDb.inputs;
                labels = dadosDb.labels;
            }
            // Acumula os dados no globalDataStore
            this.globalDataStore.inputs = this.globalDataStore.inputs.concat(inputs);
            this.globalDataStore.labels = this.globalDataStore.labels.concat(labels);
            this.statusMessage = "Dados acumulados com sucesso.";
        },
        async applyModelToMesh(segmenter = false) {
            this.infoStatusMessage = 'info'
            this.statusMessage = "Aplicando IA ao modelo...";
            const scenario = createScenario(this.activeObject, null); // Cria o cenário sem o sphereMap
            // eslint-disable-next-line no-unused-vars
            const { inputTensor } = prepareData(scenario);

            // Testa o modelo com os dados preparados
            if (this.tensorFlow.length > 0) {
                testModelMesh(this.tensorFlow.map(tfModel => tfModel.model), inputTensor, this.activeObject)

                this.statusMessage = "IA Multipla aplicada ao modelo com sucesso.";

                this.$refs.progressDialog.cancelProcess();
                if (segmenter) {
                    this.$refs.progressDialog.showProgressDialog("Executando Segmentação. Aguarde...", 10)
                    setTimeout(() => { this.gumSearch(); }, 1000)
                }
            } else {
                this.statusMessage = "TensorFlow Multiplo não encontrado. Treine os modelos primeiro.";
            }
        },
        async initializeModel(id = '') {
            // Tente carregar o modelo salvo
            this.tensorFlow = []
            const loadedModel = await this.loadTensorModel(id);
            if (loadedModel) {
                this.modelTensorFlow = loadedModel;

                // loadedModel.compile({
                //         optimizer: tf.train.adam(0.01),
                //         loss: "categoricalCrossentropy",
                //         metrics: ["accuracy"]
                //     });

                // // Criar um novo modelo e ajustar o dropout
                // const newModel = tf.sequential();
                // const dropoutRate = 0.15;  // Defina o novo valor de dropout

                // // Recriar as camadas do modelo original, ajustando o dropout
                // loadedModel.layers.forEach((layer) => {
                //     if (layer instanceof tf.layers.dropout) {
                //         newModel.add(tf.layers.dropout({ rate: dropoutRate })); // nova taxa de dropout
                //     } else {
                //         newModel.add(layer); // copie outras camadas diretamente
                //     }
                // });

                // // Ajuste a taxa de aprendizado e compile o modelo atualizado
                // const newLearningRate = 0.002;
                // const newOptimizer = tf.train.adam(newLearningRate);

                this.modelTensorFlow.compile({
                    optimizer: tf.train.adam(0.01),
                    loss: "categoricalCrossentropy",
                    metrics: ["accuracy"],
                });

                //this.modelTensorFlow = newModel; // Atualize o modelo carregado com o novo

                this.infoStatusMessage = 'success';
                this.statusMessage = "IA carregada e pronta para uso.";
                this.iaActive = 'yellow'
            } else {
                if (!this.modelTensorFlow) {
                    this.modelTensorFlow = createModel();
                    this.infoStatusMessage = 'warning';
                    this.statusMessage = "Novo modelo TensorFlow criado.";
                }
            }
        },
        trainModelWithData() {
            this.infoStatusMessage = 'info'
            this.statusMessage = "Iniciando o treinamento do modelo...";

            let inputTensor, labelTensor;
            if (this.globalDataStore.inputs.length && this.globalDataStore.labels.length) {
                ({ inputTensor, labelTensor } = prepareData(null, this.globalDataStore.inputs, this.globalDataStore.labels));
                this.statusMessage = "Usando dados acumulados para treinamento.";
            } else {
                const spheresMap = this.analyzeSpheresBVH(this.activeObject.geometry, 0.25);
                const scenario = createScenario(this.activeObject, spheresMap);
                ({ inputTensor, labelTensor } = prepareData(scenario));
                this.statusMessage = "Dados extraídos do cenário.";
            }

            //const { trainX, trainY, testX, testY } = splitData(inputTensor, labelTensor, 1);

            if (!this.modelTensorFlow) {
                this.modelTensorFlow = createModel();
                this.statusMessage = "Modelo TensorFlow criado.";
            }

            trainModel(this.modelTensorFlow, inputTensor, labelTensor, 1, this).then(() => {
                this.statusMessage = "Treinamento concluído com sucesso.";
                this.saveTensorModel(this.modelTensorFlow, {}, this.selectedSet)
                //this.applyModelToMesh()
                //evaluateModel(this.modelTensorFlow, testX, testY);
            });
        },
        formatFileSize(size) {
            return (size / 1024 / 1024).toFixed(2) + ' MB';
        },
        async fetchFileList() {
            fetch(`${process.env.VUE_APP_API_URL}models`)
                .then(response => response.json())
                .then(data => {
                    this.fileList = data;
                    this.showFileDialog = true;
                })
                .catch(error => console.error('Erro ao recuperar dados:', error));

        },
        loadFile(file) {
            this.showFileDialog = false;
            this.$refs.progressDialog.showProgressDialog("Carregando e Preparando STL. Aguarde...", 10)
            setTimeout(() => { this.dbLoadModel(file.id); }, 1000)
        },
        deleteFile(file, all = false) {
            this.showFileDialog = false;
            this.$refs.progressDialog.showProgressDialog("Removendo dados do servidor. Aguarde...", 10)
            setTimeout(() => { this.dbDeleteDentalMap(file.id, all); }, 1000)
        },
        flattenMesh() {
            if (!this.activeObject || !this.activeObject.geometry) {
                console.error('Não há objeto ativo ou geometria disponível.');
                return;
            }

            // Clone a geometria para não alterar o mesh original
            const originalGeometry = this.activeObject.geometry.clone();
            originalGeometry.computeBoundingBox(); // Garante que a bounding box está calculada

            const flattenedGeometry = new THREE.BufferGeometry();

            // Suponha que estamos trabalhando com BufferGeometry
            const positions = originalGeometry.attributes.position.array;
            const flattenedPositions = [];

            // Passar por cada vértice, ignorar a coordenada Y
            for (let j = 0; j < 0.1; j += 0.1)
                for (let i = 0; i < positions.length; i += 3) {
                    flattenedPositions.push(positions[i], j, positions[i + 2]); // X, 0, Z
                }

            // Atribuir as novas posições achatadas à geometria
            flattenedGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(flattenedPositions), 3));

            // Crie uma malha com a nova geometria achatada
            const material = this.activeObject.material ? this.activeObject.material.clone() :
                new THREE.MeshBasicMaterial({ color: 0x00ff00, side: THREE.DoubleSide, transparent: true, opacity: 0.5 });
            const flattenedMesh = new THREE.Mesh(flattenedGeometry, material);

            flattenedMesh.geometry.computeVertexNormals();

            // Obter o plano de corte
            const cuttingPlane = this.scene.children.find(child => child.userData.isCuttingPlane === true);
            if (!cuttingPlane) {
                console.error('Plano de corte não encontrado.');
                return;
            }

            // Ajustar a rotação para corresponder à do plano de corte
            flattenedMesh.rotation.copy(cuttingPlane.rotation);

            // Rotacionar 90 graus em X para alinhar com o plano de corte
            flattenedMesh.rotateX(Math.PI / 2);

            const planeDirection = cuttingPlane.getWorldDirection(new THREE.Vector3());
            const angleY = Math.atan2(planeDirection.x, planeDirection.z);
            flattenedMesh.rotateY(-angleY);

            // Alinhar a malha achatada com a altura do plano de corte
            // A posição Y da malha deve ser ajustada para corresponder à do plano
            flattenedMesh.position.copy(cuttingPlane.position);

            // Adicione a tampa à cena (se ainda não foi adicionada)
            this.scene.add(flattenedMesh);

            // Opcional: Retornar a malha achatada caso seja necessário
            return flattenedMesh;
        },
        setLoadingStatusForAction(action, loadingStatus) {
            const itemIndex = this.sideBarItems.findIndex(item => item.action === action);
            if (itemIndex !== -1) {
                // Vue 3 é reativo com atribuições diretas graças ao sistema Proxy
                this.sideBarItems[itemIndex].loading = loadingStatus;
            }
        },
        async executeActionWithLoading(action, actionFunction, delay = 500) {
            // Ativa o estado de loading para a ação especificada
            this.setLoadingStatusForAction(action, true);

            // Aguarda um breve delay antes de executar a função
            // O uso de setTimeout dentro de uma Promise permite usar await para aguardar o término do delay
            await new Promise(resolve => setTimeout(resolve, delay));

            try {
                // Executa a função passada como argumento
                // Se a função for assíncrona, o await garante que esperemos sua conclusão
                await actionFunction();
            } catch (error) {
                console.error("Erro durante a execução da ação:", error);
                // Aqui você pode adicionar qualquer manipulação de erro específica, como mostrar uma mensagem para o usuário
            } finally {
                // Desativa o estado de loading independentemente do resultado da função
                this.setLoadingStatusForAction(action, false);
            }
        },
        startSESAction() {
            // Dispara a ação startEdgeSmoothing do Vuex
            if (this.$store.state.editor3D.currentAction !== "smoothingEdges") {
                const points = this.initializeSES();
                this.identifyBorderVerticesDelaunay(points);
                //this.identifyBorderVertices();
                //this.flattenMesh();
            } else {
                this.$store.dispatch('editor3D/stopEdgeSmoothing');
                if (this.brushMesh) {
                    this.brushMesh.visible = false;
                    this.smoothingMeshEdges.dispose();
                    this.smoothingMeshEdges = null;
                }
            }
        },
        createSmoothShapeFromContour(contourPoints3D) {
            // Obtenha os pontos de contorno do Vuex store
            //const contourPoints3D = this.$store.getters['editor3D/contourPoints'];

            // Verifique se há pontos suficientes para criar um contorno
            if (!contourPoints3D || contourPoints3D.length < 3) {
                console.error('Não há pontos de contorno suficientes para criar um shape suavizado.');
                return;
            }

            // Cria uma curva Catmull-Rom que passa pelos pontos do contorno
            const curve = new THREE.CatmullRomCurve3(contourPoints3D, false, 'catmullrom', 0.5);

            // Obter os pontos da curva suavizada
            const smoothPoints = curve.getPoints(25);  // A quantidade de pontos pode ser ajustada para maior suavidade

            // Crie um novo shape
            const shape = new THREE.Shape();

            // Adicione o primeiro ponto como ponto de movimento (MoveTo)
            shape.moveTo(smoothPoints[0].x, smoothPoints[0].z);

            // Adicione os pontos subsequentes como linhas curvas (SplineThru)
            // Nota: THREE.CurvePath foi descontinuado, então usamos SplineThru diretamente no Shape
            shape.splineThru(smoothPoints.slice(1).map(p => new THREE.Vector2(p.x, p.z)));

            return shape;
        },
        createExtrudedModel() {

            if (!this.activeObject || !this.activeObject.geometry) {
                console.error('Não há objeto ativo ou geometria para extrudar.');
                return;
            }

            // Certifique-se de que a geometria do objeto ativo é uma BufferGeometry com normais computadas
            if (!this.activeObject.geometry.isBufferGeometry) {
                console.error('A geometria do objeto ativo não é uma BufferGeometry ou não possui normais.');
                return;
            }

            const activeGeometry = this.activeObject.geometry;

            // Create edge geometry from the active object's geometry
            const edges = new THREE.EdgesGeometry(activeGeometry, 90);
            const positionsArray = edges.attributes.position.array;

            // Convert the flat array into an array of Vector3
            let vertices = [];
            for (let i = 0; i < positionsArray.length; i += 3) {
                vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
            }

            // Obtain unique vertices
            const uniqueVertices = this.uniqueVerticesFunction(vertices);

            // Map vertices to edges
            const vertexToEdgeMap = this.createVertexToEdgeMap(edges);

            // Order vertices to form a connected edge path
            let orderedVertices = this.createOrderedEdgePath(uniqueVertices, vertexToEdgeMap);

            const shape = this.createSmoothShapeFromContour(orderedVertices);

            // Definir configurações de extrusão
            const extrudeSettings = {
                steps: 2,
                depth: 1,
                bevelEnabled: true,
                bevelThickness: 0.5,
                bevelSize: 0.5,
                bevelOffset: 1,
                bevelSegments: 3
            };

            // Criar a geometria extrudada
            const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
            const material = new THREE.MeshPhongMaterial({ color: 0xdddddd, specular: 0x666666, shininess: 400, side: THREE.DoubleSide });

            const extrudedMesh = new THREE.Mesh(geometry, material);

            geometry.computeVertexNormals();
            this.calculateVertexNormals(geometry);

            // Adicionar a malha extrudada à cena
            this.scene.add(extrudedMesh);

            // Opcional: Se você deseja manter uma referência para esta malha para uso futuro
            this.extrudedShape = extrudedMesh;
        },
        removeObjectFromScene(objectToRemove) {
            if (!objectToRemove || !this.scene) return;

            // Encontra o objeto na cena pelo uuid
            const object = this.scene.children.find(child => child.uuid === objectToRemove.uuid);

            if (object) {
                // Remove o objeto da cena
                this.scene.remove(object);

                // Opcional: Limpa o objeto da memória se não for mais necessário
                if (object.geometry) object.geometry.dispose();
                if (object.material) {
                    // Se for um material composto, iterar sobre todos os materiais
                    if (Array.isArray(object.material)) {
                        object.material.forEach(material => material.dispose());
                    } else {
                        object.material.dispose();
                    }
                }
                if (object.texture) object.texture.dispose();
            }
        },
        calculateVertexNormals(geometry) {
            const vertices = geometry.attributes.position.array;
            const normals = geometry.attributes.normal.array;
            let vertexNormals = [];
            let vertexMap = new Map();

            // Função de ajuda para formatar a chave com segurança
            const formatKey = (x, y, z) => {
                // Tentar converter strings para números
                const numX = parseFloat(x);
                const numY = parseFloat(y);
                const numZ = parseFloat(z);

                // Verificar se algum valor convertido é NaN
                if (isNaN(numX) || isNaN(numY) || isNaN(numZ)) {
                    // Retornar um valor que indica um erro na conversão
                    return 'invalid,invalid,invalid';
                }
                // Usar números convertidos e formatá-los
                return `${numX.toFixed(8)},${numY.toFixed(8)},${numZ.toFixed(8)}`;
            };

            // Agrupar vértices que compartilham a mesma posição
            for (let i = 0; i < vertices.length; i += 9) {
                for (let j = 0; j < 3; j++) {
                    // Criar uma chave única para a posição do vértice
                    let key = formatKey(
                        vertices[i + j * 3],
                        vertices[i + j * 3 + 1],
                        vertices[i + j * 3 + 2]
                    );
                    if (!vertexMap.has(key)) {
                        vertexMap.set(key, []);
                    }
                    vertexMap.get(key).push(i + j * 3); // Armazenar o índice do vértice
                }
            }

            // Calcular as normais dos vértices
            for (let i = 0; i < vertices.length; i += 9) {
                // Calcular a normal do triângulo
                let normal = this.calculateNormalFromVertices(vertices, i);

                // Distribuir a normal do triângulo para os vértices compartilhados
                for (let j = 0; j < 3; j++) {
                    let vertexIndex = i + j * 3;
                    let key = formatKey(vertices[vertexIndex], vertices[vertexIndex + 1], vertices[vertexIndex + 2])
                    for (let sharedVertexIndex of vertexMap.get(key)) {
                        if (!vertexNormals[sharedVertexIndex]) {
                            vertexNormals[sharedVertexIndex] = new THREE.Vector3();
                        }
                        vertexNormals[sharedVertexIndex].add(normal);
                    }
                }
            }

            // Normalizar as normais dos vértices
            for (let i = 0; i < vertexNormals.length; i += 3) {
                if (vertexNormals[i]) {
                    let normal = vertexNormals[i];
                    normal.normalize();
                    normals[i] = normal.x;
                    normals[i + 1] = normal.y;
                    normals[i + 2] = normal.z;
                }
            }

            // Atualizar o atributo de normal da geometria
            geometry.attributes.normal.needsUpdate = true;
        },
        gumCutter(distanceThreshold = 9) {

            // Encontrar todos os meshes de dentes dentro do activeObject
            const toothMeshes = this.activeObject.children.filter(child => child.userData.objectType === "tooth");
            if (toothMeshes.length === 0) {
                console.error('No tooth meshes found in the active object.');
                return;
            }

            // Armazenar os centros das boundingBoxes dos dentes em um array de vetores
            const toothCenters = toothMeshes.map(toothMesh => {
                const boundingBox = new THREE.Box3().setFromObject(toothMesh);
                const center = new THREE.Vector3();
                boundingBox.getCenter(center);
                return center;
            });

            // Função para determinar se um ponto está dentro do limite de distância em relação a qualquer centro de dente
            const isWithinToothLimit = (vertex) => {
                return toothCenters.some(center => vertex.distanceTo(center) < distanceThreshold);
            };

            // Função para cortar um mesh com base na distância em relação aos dentes
            const cutMesh = (mesh) => {
                if (!mesh.geometry) {
                    console.error('No geometry found in the mesh.');
                    return;
                }

                // Clonar a geometria do mesh para não modificar a original
                const clonedGeometry = mesh.geometry.clone();
                const positionAttribute = clonedGeometry.getAttribute('position');

                const newVertices = [];

                // Iterar sobre cada triângulo da geometria (cada conjunto de 3 vértices)
                for (let i = 0; i < positionAttribute.count; i += 3) {
                    const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                    const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                    const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);

                    // Adicionar o triângulo se estiver dentro do limite de distância em relação aos dentes
                    if (isWithinToothLimit(v1) || isWithinToothLimit(v2) || isWithinToothLimit(v3)) {
                        newVertices.push(v1, v2, v3);
                    }
                }

                // Se nenhum vértice foi adicionado, retorne
                if (newVertices.length === 0) {
                    console.error('No vertices found within the tooth distance limit.');
                    return;
                }

                // Crie uma nova BufferGeometry a partir dos vértices filtrados
                const newGeometry = new THREE.BufferGeometry().setFromPoints(newVertices);
                newGeometry.computeVertexNormals(); // Recalcular as normais dos vértices
                this.calculateVertexNormals(newGeometry);

                // Substitua a geometria do mesh pela nova geometria cortada
                mesh.geometry.dispose(); // Libere a geometria antiga
                mesh.geometry = newGeometry;
                mesh.geometry.needsUpdate = true;
            };

            // Encontrar o mesh com userData.objectType igual a "gums" dentro do activeObject
            const gumsMesh = this.activeObject.children.find(child => child.userData.objectType === "gums");
            if (!gumsMesh) {
                console.error('No gums mesh found in the active object.');
                return;
            }

            // Cortar o mesh ativo de gengiva com base na proximidade aos dentes
            cutMesh(gumsMesh);

            // Encontrar outros meshes com o mesmo userData.modelType na cena, mas não dentro do activeObject
            const modelType = this.activeObject.userData.modelType;
            const otherMeshes = this.scene.children.filter(child =>
                child !== this.activeObject && // Certifique-se de não incluir o próprio activeObject
                child.userData.modelType === modelType && // Mesmo modelType
                child.geometry // Verifique se o mesh tem geometria
            );

            // Cortar todos os outros meshes encontrados
            otherMeshes.forEach(mesh => cutMesh(mesh));
        },
        cutActiveObject(removeAbove, distanceThreshold = 9) {
            const cuttingPlane = this.scene.children.find(child => child.userData.isCuttingPlane);
            if (!cuttingPlane) {
                console.error('No cutting plane found in the scene.');
                return;
            }

            // Obter a normal do plano no espaço do mundo e a posição do plano
            const planeNormal = new THREE.Vector3(0, 0, 1); // Supõe-se que a normal local do plano é Z+
            planeNormal.applyQuaternion(cuttingPlane.quaternion).normalize();

            const planePosition = cuttingPlane.position.clone();

            // Função para determinar se um ponto está acima do plano de corte
            const isAbovePlane = (vertex) => {
                const directionFromPlane = vertex.clone().sub(planePosition);
                const distance = directionFromPlane.dot(planeNormal);
                return distance > 0;
            };

            // Encontrar todos os meshes de dentes dentro do activeObject
            const toothMeshes = this.activeObject.children.filter(child => child.userData.objectType === "tooth");
            if (toothMeshes.length === 0) {
                console.error('No tooth meshes found in the active object.');
                return;
            }

            // Armazenar os centros das boundingBoxes dos dentes em um array de vetores
            const toothCenters = toothMeshes.map(toothMesh => {
                const boundingBox = new THREE.Box3().setFromObject(toothMesh);
                const center = new THREE.Vector3();
                boundingBox.getCenter(center);
                return center;
            });

            // Função para determinar se um ponto está dentro do limite de distância em relação a qualquer centro de dente
            const isWithinToothLimit = (vertex) => {
                return toothCenters.some(center => vertex.distanceTo(center) < distanceThreshold);
            };

            // Função para cortar um mesh com base na distância em relação aos dentes
            const cutMesh = (mesh) => {
                if (!mesh.geometry) {
                    console.error('No geometry found in the mesh.');
                    return;
                }

                // Clonar a geometria do mesh para não modificar a original
                const clonedGeometry = mesh.geometry.clone();
                const positionAttribute = clonedGeometry.getAttribute('position');

                const newVertices = [];

                // Iterar sobre cada triângulo da geometria (cada conjunto de 3 vértices)
                for (let i = 0; i < positionAttribute.count; i += 3) {
                    const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                    const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                    const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);

                    // Adicionar o triângulo se estiver dentro do limite de distância em relação aos dentes
                    if (isWithinToothLimit(v1) || isWithinToothLimit(v2) || isWithinToothLimit(v3)) {
                        if ((removeAbove && !(isAbovePlane(v1) || isAbovePlane(v2) || isAbovePlane(v3))) ||
                            (!removeAbove && isAbovePlane(v1) && isAbovePlane(v2) && isAbovePlane(v3))) {
                            newVertices.push(v1, v2, v3);
                        }
                    }
                }

                // Se nenhum vértice foi adicionado, retorne
                if (newVertices.length === 0) {
                    console.error('No vertices found within the tooth distance limit.');
                    return;
                }

                // Crie uma nova BufferGeometry a partir dos vértices filtrados
                const newGeometry = new THREE.BufferGeometry().setFromPoints(newVertices);
                newGeometry.computeVertexNormals(); // Recalcular as normais dos vértices
                this.calculateVertexNormals(newGeometry);

                // Substitua a geometria do mesh pela nova geometria cortada
                mesh.geometry.dispose(); // Libere a geometria antiga
                mesh.geometry = newGeometry;
                mesh.geometry.needsUpdate = true;
            };

            // Encontrar o mesh com userData.objectType igual a "gums" dentro do activeObject
            const gumsMesh = this.activeObject.children.find(child => child.userData.objectType === "gums");
            if (!gumsMesh) {
                console.error('No gums mesh found in the active object.');
                return;
            }

            // Cortar o mesh ativo de gengiva com base na proximidade aos dentes
            cutMesh(gumsMesh);

            // Encontrar outros meshes com o mesmo userData.modelType na cena, mas não dentro do activeObject
            const modelType = this.activeObject.userData.modelType;
            const otherMeshes = this.scene.children.filter(child =>
                child !== this.activeObject && // Certifique-se de não incluir o próprio activeObject
                child.userData.modelType === modelType && // Mesmo modelType
                child.geometry // Verifique se o mesh tem geometria
            );

            // Cortar todos os outros meshes encontrados
            otherMeshes.forEach(mesh => cutMesh(mesh));
        },
        cutActiveObject___(removeAbove) {
            // Encontrar o cuttingPlane na cena baseado na propriedade isCuttingPlane
            const cuttingPlane = this.scene.children.find(child => child.userData.isCuttingPlane);
            if (!cuttingPlane) {
                console.error('No cutting plane found in the scene.');
                return;
            }

            // Obter a normal do plano no espaço do mundo e a posição do plano
            const planeNormal = new THREE.Vector3(0, 0, 1); // Supõe-se que a normal local do plano é Z+
            planeNormal.applyQuaternion(cuttingPlane.quaternion).normalize();

            const planePosition = cuttingPlane.position.clone();

            // Função para determinar se um ponto está acima do plano de corte
            const isAbovePlane = (vertex) => {
                const directionFromPlane = vertex.clone().sub(planePosition);
                const distance = directionFromPlane.dot(planeNormal);
                return distance > 0;
            };

            // Função para cortar um mesh com base no plano de corte
            const cutMesh = (mesh) => {
                if (!mesh.geometry) {
                    console.error('No geometry found in the mesh.');
                    return;
                }

                // Clonar a geometria do mesh para não modificar a original
                const clonedGeometry = mesh.geometry.clone();
                const positionAttribute = clonedGeometry.getAttribute('position');

                const newVertices = [];

                // Iterar sobre cada triângulo da geometria (cada conjunto de 3 vértices)
                for (let i = 0; i < positionAttribute.count; i += 3) {
                    const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                    const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                    const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);

                    // Adicionar triângulo se todos ou nenhum dos pontos estiverem acima do plano,
                    // dependendo de 'removeAbove'
                    if ((removeAbove && !(isAbovePlane(v1) || isAbovePlane(v2) || isAbovePlane(v3))) ||
                        (!removeAbove && isAbovePlane(v1) && isAbovePlane(v2) && isAbovePlane(v3))) {
                        newVertices.push(v1, v2, v3);
                    }
                }

                // Se nenhum vértice foi adicionado, retorne
                if (newVertices.length === 0) {
                    console.error('No vertices found above or below the cutting plane.');
                    return;
                }

                // Crie uma nova BufferGeometry a partir dos vértices cortados
                const newGeometry = new THREE.BufferGeometry().setFromPoints(newVertices);
                newGeometry.computeVertexNormals(); // Recalcular as normais dos vértices
                this.calculateVertexNormals(newGeometry);

                // Substitua a geometria do mesh pela nova geometria cortada
                mesh.geometry.dispose(); // Libere a geometria antiga
                mesh.geometry = newGeometry;
                mesh.geometry.needsUpdate = true;
            };

            // Encontrar o mesh com userData.objectType igual a "gums" dentro do activeObject
            const gumsMesh = this.activeObject.children.find(child => child.userData.objectType === "gums");
            if (!gumsMesh) {
                console.error('No gums mesh found in the active object.');
                return;
            }

            // Cortar o mesh ativo
            cutMesh(gumsMesh);

            // Encontrar outro mesh com o mesmo userData.modelType na cena, mas não dentro do activeObject
            const modelType = this.activeObject.userData.modelType;
            const otherMeshes = this.scene.children.filter(child =>
                child !== this.activeObject && // Certifique-se de não incluir o próprio activeObject
                child.userData.modelType === modelType && // Mesmo modelType
                child.geometry // Verifique se o mesh tem geometria
            );


            // Cortar todos os outros meshes encontrados
            otherMeshes.forEach(mesh => cutMesh(mesh));
        },
        cutActiveObject__(removeAbove) {
            // Encontrar o cuttingPlane na cena baseado na propriedade isCuttingPlane
            const cuttingPlane = this.scene.children.find(child => child.userData.isCuttingPlane);
            if (!cuttingPlane) {
                console.error('No cutting plane found in the scene.');
                return;
            }

            // Obter a normal do plano no espaço do mundo e a posição do plano
            const planeNormal = new THREE.Vector3(0, 0, 1); // Supõe-se que a normal local do plano é Z+
            planeNormal.applyQuaternion(cuttingPlane.quaternion).normalize();

            const planePosition = cuttingPlane.position.clone();

            // Função para determinar se um ponto está acima do plano de corte
            const isAbovePlane = (vertex) => {
                const directionFromPlane = vertex.clone().sub(planePosition);
                const distance = directionFromPlane.dot(planeNormal);
                return distance > 0;
            };

            // Encontrar o mesh com userData.objectType igual a "gums" dentro do activeObject
            const gumsMesh = this.activeObject.children.find(child => child.userData.objectType === "gums");
            if (!gumsMesh) {
                console.error('No gums mesh found in the active object.');
                return;
            }

            // Se o gumsMesh não tiver geometria, retorne
            if (!gumsMesh.geometry) {
                console.error('No geometry found in the gums mesh.');
                return;
            }

            // Clonar a geometria do gumsMesh para não modificar a original
            const clonedGeometry = gumsMesh.geometry.clone();
            const positionAttribute = clonedGeometry.getAttribute('position');

            const newVertices = [];

            // Iterar sobre cada triângulo da geometria (cada conjunto de 3 vértices)
            for (let i = 0; i < positionAttribute.count; i += 3) {
                const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);

                // Adicionar triângulo se todos ou nenhum dos pontos estiverem acima do plano,
                // dependendo de 'removeAbove'
                if ((removeAbove && !(isAbovePlane(v1) || isAbovePlane(v2) || isAbovePlane(v3))) ||
                    (!removeAbove && isAbovePlane(v1) && isAbovePlane(v2) && isAbovePlane(v3))) {
                    newVertices.push(v1, v2, v3);
                }
            }

            // Se nenhum vértice foi adicionado, retorne
            if (newVertices.length === 0) {
                console.error('No vertices found above or below the cutting plane.');
                return;
            }

            // Crie uma nova BufferGeometry a partir dos vértices cortados
            const newGeometry = new THREE.BufferGeometry().setFromPoints(newVertices);
            newGeometry.computeVertexNormals(); // Recalcular as normais dos vértices
            this.calculateVertexNormals(newGeometry);

            // Substitua a geometria do gumsMesh pela nova geometria cortada
            gumsMesh.geometry.dispose(); // Libere a geometria antiga
            gumsMesh.geometry = newGeometry;
            gumsMesh.geometry.needsUpdate = true;
        },
        cutActiveObject_(removeAbove) {
            // Encontrar o cuttingPlane na cena baseado na propriedade isCuttingPlane
            const cuttingPlane = this.scene.children.find(child => child.userData.isCuttingPlane);
            if (!cuttingPlane) {
                console.error('No cutting plane found in the scene.');
                return;
            }

            // Obter a normal do plano no espaço do mundo e a posição do plano
            const planeNormal = new THREE.Vector3(0, 0, 1); // Supõe-se que a normal local do plano é Z+
            planeNormal.applyQuaternion(cuttingPlane.quaternion).normalize();

            const planePosition = cuttingPlane.position.clone();


            // Função para determinar se um ponto está acima do plano de corte
            const isAbovePlane = (vertex) => {
                const directionFromPlane = vertex.clone().sub(planePosition);
                const distance = directionFromPlane.dot(planeNormal);
                return distance > 0;
            };

            // Se o objeto ativo não for definido ou não tiver geometria, retorne
            if (!this.activeObject || !this.activeObject.geometry) {
                console.error('No active object with geometry to cut.');
                return;
            }

            // Clonar a geometria do objeto ativo para não modificar a original
            const clonedGeometry = this.activeObject.geometry.clone();
            const positionAttribute = clonedGeometry.getAttribute('position');

            const newVertices = [];

            // Iterar sobre cada triângulo da geometria (cada conjunto de 3 vértices)
            for (let i = 0; i < positionAttribute.count; i += 3) {
                const v1 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i);
                const v2 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 1);
                const v3 = new THREE.Vector3().fromBufferAttribute(positionAttribute, i + 2);

                // Adicionar triângulo se todos ou nenhum dos pontos estiverem acima do plano,
                // dependendo de 'removeAbove'
                if ((removeAbove && !(isAbovePlane(v1) || isAbovePlane(v2) || isAbovePlane(v3))) ||
                    (!removeAbove && isAbovePlane(v1) && isAbovePlane(v2) && isAbovePlane(v3))) {
                    newVertices.push(v1, v2, v3);
                }
            }

            // Se nenhum vértice foi adicionado, retorne
            if (newVertices.length === 0) {
                console.error('No vertices found above or below the cutting plane.');
                return;
            }

            // Crie uma nova BufferGeometry a partir dos vértices cortados
            const newGeometry = new THREE.BufferGeometry().setFromPoints(newVertices);
            newGeometry.computeVertexNormals(); // Recalcular as normais dos vértices
            this.calculateVertexNormals(newGeometry);


            // Substitua a geometria do objeto ativo pela nova geometria cortada
            this.activeObject.geometry.dispose(); // Libere a geometria antiga
            this.activeObject.geometry = newGeometry;
            this.activeObject.geometry.needsUpdate = true;

        },
        create3DSeamDelaunay(cv1, cv2) {
            // Unindo os dois arrays de vetores
            const combinedVertices = [...cv1, ...cv2];

            // Chamando a função genérica de triangulação de Delaunay com o array combinado
            const newGeometry = this.delaunayTriangulation(combinedVertices);

            // Verificando se a nova geometria foi criada com sucesso
            if (newGeometry) {
                return newGeometry;
            } else {
                console.error('Falha ao criar a costura 3D');
                return null;
            }
        },
        create3DSeam(cv1, cv2) {
            var geometry = new THREE.BufferGeometry();

            // Concatenando os conjuntos de vértices em um único array
            var vertices = cv1.concat(cv2);

            // Convertendo os vértices para um array unidimensional
            var verticesArray = new Float32Array(vertices.length * 3);
            vertices.forEach((vertex, index) => {
                verticesArray[index * 3] = vertex.x;
                verticesArray[index * 3 + 1] = vertex.y;
                verticesArray[index * 3 + 2] = vertex.z;
            });

            geometry.setAttribute('position', new THREE.BufferAttribute(verticesArray, 3));

            // Criando as faces da costura
            var indices = [];
            for (var i = 0; i < cv1.length - 1; i++) {
                indices.push(i, i + cv1.length, i + 1, i + 1, i + cv1.length, i + cv1.length + 1);
            }

            // Correção na adição das faces para fechar a estrutura
            indices.push(cv1.length - 1, 2 * cv1.length - 1, 0);
            indices.push(0, cv1.length, cv1.length - 1);

            var indicesArray = new Uint16Array(indices);
            geometry.setIndex(new THREE.BufferAttribute(indicesArray, 1));

            geometry.computeVertexNormals();

            return geometry;
        },
        removeAllHelperObjects() {
            const helperObjects = this.scene.children.filter(child => child.userData.helper);

            helperObjects.forEach(obj => {
                if (obj.geometry) obj.geometry.dispose();
                if (obj.material) obj.material.dispose();
                this.scene.remove(obj);
            });
        },
        handleObjectClickFromList(object) {
            // Lógica para lidar com o objeto clicado
            this.activeObject = object;
            this.selectedTooth = null;
            if (object.userData.modelType) {
                this.activeDentalArch = object.userData.modelType;
            } else {
                this.activeDentalArch = null;
            }
        },
        initiateOcclusionPlan() {
            this.$store.dispatch('editor3D/startOcclusionPlanCreation');
            this.showDialog = (this.currentAction !== null); // Controla a visibilidade de um diálogo de instruções
        },
        async initiateDentalArch() {

            if (this.activeDentalArch) {

                this.statusMessage = '';
                // Verifica se já está no processo de criação do arco dentário
                if (this.$store.state.editor3D.currentAction === 'creatingDentalArch') {
                    // Se já existem 5 pontos, tenta criar o arco dentário
                    if (this.$store.state.editor3D.contourPoints.length === 5) {
                        await this.$store.dispatch('editor3D/createDentalArch');
                    }
                    // Encerra a criação do arco dentário
                    await this.$store.dispatch('editor3D/endDentalArchCreation');
                } else {
                    // Inicia a criação do arco dentário
                    await this.$store.dispatch('editor3D/startDentalArchCreation', this.activeDentalArch);
                    // Verifica se já existem 4 pontos de contorno salvos
                    if (this.idealArchStartPoints[this.activeDentalArch].length === 5) {
                        // Se sim, assume que queremos ajustar o arco existente
                        // Atualiza os pontos de contorno no Vuex, se necessário
                        await this.$store.dispatch('editor3D/setContourPoints', this.idealArchStartPoints[this.activeDentalArch]);
                        // Chama a função para atualizar/visualizar o contorno diretamente
                        this.updateContour();
                    }
                }
            } else {
                this.statusMessage = this.$t('noArchSelected');
            }
        },
        async adjustArchScale(scaleType, scaleFactor) {
            if (!this.activeDentalArch || !this.idealArchStartPoints[this.activeDentalArch]) {
                return; // Verifica se a arcada está definida e se há pontos para trabalhar
            }

            const points = this.idealArchStartPoints[this.activeDentalArch];
            let newPoints;

            switch (scaleType) {
                case 'fullArch':
                    newPoints = this.scaleArchPoints(points, scaleFactor, scaleFactor);
                    break;
                case 'ends':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [0, 4]); // Considerando 0-indexed e pontos 1 e 5
                    break;
                case 'midPoints':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [1, 3]); // Considerando 0-indexed e pontos 2 e 4
                    break;
                case 'centerPoint':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [2]); // Considerando 0-indexed e ponto 3
                    break;
                case 'endsLeft':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [0]); // Considerando 0-indexed e pontos 1 e 5
                    break;
                case 'midPointsLeft':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [1]); // Considerando 0-indexed e pontos 2 e 4
                    break;
                case 'endsRight':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [4]); // Considerando 0-indexed e pontos 1 e 5
                    break;
                case 'midPointsRight':
                    newPoints = this.scaleSpecificPoints(points, scaleFactor, [3]); // Considerando 0-indexed e pontos 2 e 4
                    break;
                default:
                    return;
            }

            this.idealArchStartPoints[this.activeDentalArch] = newPoints;
            const curve = new THREE.CatmullRomCurve3(newPoints, false, 'catmullrom', 0.5);
            const curvePoints = curve.getPoints(256);
            this.idealArchPoints[this.activeDentalArch] = curvePoints;

            await this.$store.dispatch('editor3D/setContourPoints', newPoints);
            if (this.currentAction === 'creatingDentalArch')
                this.updateContour(); // Atualiza visualmente o arco
        },
        scaleArchPoints(points, scaleX, scaleZ) {
            return points.map(point => new THREE.Vector3(
                point.x * scaleX,
                point.y,
                point.z * scaleZ
            ));
        },
        scaleSpecificPoints(points, scale, indices) {
            return points.map((point, index) => {
                if (indices.includes(index)) {
                    return new THREE.Vector3(
                        point.x * scale,
                        point.y,
                        point.z * scale
                    );
                }
                return point;
            });
        },
        exportSTL() {
            if (!this.activeObject) {
                console.error('Não há objeto ativo selecionado para exportar.');
                return;
            }

            // Cria uma instância do STLExporter
            const exporter = new STLExporter();

            const options = { binary: true }

            // Exporta o activeObject como STL
            const stlString = exporter.parse(this.activeObject, options);

            // Cria um blob a partir da string STL
            const blob = new Blob([stlString], { type: 'application/octet-stream' });

            // Cria um link e dispara o download
            const link = document.createElement('a');
            link.style.display = 'none';
            document.body.appendChild(link); // Necessário para o Firefox

            // Cria um URL para o blob
            link.href = URL.createObjectURL(blob);

            // Define o nome do arquivo para download
            link.download = (this.activeObject.userData.name) ? `${this.activeObject.userData.name}.stl` : 'ortho-model.stl';

            // Dispara o download
            link.click();

            // Limpeza
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        },
        loadDentalMap(file) {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const content = e.target.result;
                    try {
                        const newDentalMap = JSON.parse(content);
                        // Usa o spread operator para combinar o conteúdo existente com o novo
                        try {
                            this.addEigenvectorsToDentalMap(newDentalMap);
                        } finally {
                            this.dentalMap = { ...this.dentalMap, ...newDentalMap };
                        }
                        this.executeActionWithLoading('createDentalMesh',
                            () => {
                                this.createDentalMeshGroup(newDentalMap);
                                this.createBoundingBoxMeshForTeeth(false)
                            }, 500);

                    } catch (error) {
                        console.error('Erro ao ler o arquivo JSON:', error);
                    }
                };
                reader.readAsText(file); // Lê o arquivo como texto
            }
        },
        createOBBFromMesh(mesh) {
            // Extrai vértices e centroide
            const { vertices, centroid } = this.convertMeshToVertices(mesh);

            // Aplica PCA
            const pca = new PCA(vertices);
            const eigenvectors = pca.getEigenvectors();

            // Calcula dimensões da OBB ao longo dos autovetores
            const dimensions = eigenvectors.data.map(eigenvector =>
                this.calculateDimension(vertices, eigenvector)
            );

            // Cria a geometria da caixa com base nas dimensões
            const obbGeometry = new THREE.BoxGeometry(dimensions[0], dimensions[1], dimensions[2]);
            const obbMesh = new THREE.Mesh(
                obbGeometry,
                new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true })
            );

            // Converte os eigenvetores em vetores THREE
            const xAxis = new THREE.Vector3().fromArray(eigenvectors.data[0]).normalize();
            const yAxis = new THREE.Vector3().fromArray(eigenvectors.data[1]).normalize();
            const zAxis = new THREE.Vector3().fromArray(eigenvectors.data[2]).normalize();

            // Cria a rotação a partir da base ortonormal
            const rotationMatrix = new THREE.Matrix4().makeBasis(xAxis, yAxis, zAxis);
            obbMesh.setRotationFromMatrix(rotationMatrix);

            // Posiciona no centroide
            obbMesh.position.copy(centroid);

            return {
                obb: obbMesh,
                centroid,
                eigenvectors,
                dimensions
            };
        },
        convertMeshToVertices(mesh) {
            const positions = mesh.geometry.attributes.position.array;
            const vertices = [];
            let sum = new THREE.Vector3(0, 0, 0);

            mesh.updateMatrixWorld(); // Garante que a matriz world está atualizada

            for (let i = 0; i < positions.length; i += 3) {
                const local = new THREE.Vector3(positions[i], positions[i + 1], positions[i + 2]);
                const world = local.clone().applyMatrix4(mesh.matrixWorld);
                vertices.push([world.x, world.y, world.z]);
                sum.add(world);
            }

            const numVertices = vertices.length;
            const centroid = sum.divideScalar(numVertices);

            return { vertices, centroid };
        }
        ,
        addEigenvectorsToDentalMap(dentalMap) {
            Object.keys(dentalMap).forEach(toothNumber => {
                const toothData = dentalMap[toothNumber];
                const { vertices, centroid } = this.convertIndicesToVertices(this.activeObject, toothData.segmentedTriangleIndices);
                if (vertices.length > 0) {
                    // Executa a PCA nos vértices para obter os eigenvectors
                    const pca = new PCA(vertices);
                    const eigenvectors = pca.getEigenvectors();

                    // Calcula as dimensões da OBB para cada eigenvector
                    let dimensions = eigenvectors.data.map(eigenvector => this.calculateDimension(vertices, eigenvector));

                    // Atualiza o dentalMap com os eigenvectors, o centroide e as dimensões
                    toothData.eigenvectors = eigenvectors;
                    toothData.centroid = centroid; // Salva o centroide no dentalMap para uso futuro
                    toothData.dimensions = dimensions; // Salva as dimensões da OBB
                }
            });
        },
        calculateDimension(vertices, eigenvector) {
            let minProjection = Infinity;
            let maxProjection = -Infinity;

            const v = new THREE.Vector3(...eigenvector).normalize();

            vertices.forEach(vertexArray => {
                const vertex = new THREE.Vector3(...vertexArray); // já em world space
                const projection = vertex.dot(v);
                minProjection = Math.min(minProjection, projection);
                maxProjection = Math.max(maxProjection, projection);
            });

            return maxProjection - minProjection;
        },
        convertIndicesToVertices(activeObject, triangleIndices) {
            const positions = activeObject.geometry.attributes.position.array;
            let vertices = [];
            let sumX = 0, sumY = 0, sumZ = 0;

            // Extrair vértices baseando-se nos índices dos triângulos fornecidos
            triangleIndices.forEach(triangleIdx => {
                const baseIdx = triangleIdx * 9; // Cada triângulo tem 3 vértices, cada vértice tem 3 coordenadas (x, y, z)

                // Iterar sobre os 3 vértices de cada triângulo
                for (let i = 0; i < 3; i++) {
                    const vertexIdx = baseIdx + i * 3; // Calcula o índice do início de cada vértice no array de posições
                    // Extrai as coordenadas x, y, z de cada vértice e as adiciona ao array de vértices
                    const x = positions[vertexIdx];
                    const y = positions[vertexIdx + 1];
                    const z = positions[vertexIdx + 2];
                    vertices.push([x, y, z]);

                    // Acumula as somas para o cálculo do centroide
                    sumX += x;
                    sumY += y;
                    sumZ += z;
                }
            });

            // Calcula o centroide
            const numVertices = vertices.length;
            const centroid = [sumX / numVertices, sumY / numVertices, sumZ / numVertices];

            // Retorna tanto os vértices quanto o centroide
            return { vertices, centroid };
        },
        handleFileSelected(payload) {
            const { file, action } = payload;
            console.log('Arquivo selecionado:', file.name, 'Ação:', action);
            switch (action) {
                case 'loadSegmentation':
                    this.loadDentalMap(file);
                    break;
                case 'load3SzFile':
                    this.setLoadingStatusForAction('load3SzFile', true);
                    //this.load3szFile(file);
                    this.load3szFileUnified(file);
                    this.setLoadingStatusForAction('load3SzFile', false);
                    break;
            }
        },
        findBorderMesh() {
            let targetMesh = null;
            this.scene.traverse((child) => {
                if (child.userData && child.userData.name === 'borderData') {
                    targetMesh = child;
                }
            });
            return targetMesh;
        },
        removeBorderMesh() {
            const meshToRemove = this.findBorderMesh(this.scene);

            this.removeObjectFromScene(meshToRemove)

            //console.table(meshToRemove)
            // if (meshToRemove) {
            //     // Remova o mesh da cena
            //     this.scene.remove(meshToRemove);

            //     // Libere a geometria e o material do mesh, se não for compartilhado
            //     if (meshToRemove.geometry) {
            //         meshToRemove.geometry.dispose();
            //     }
            //     if (meshToRemove.material) {
            //         if (Array.isArray(meshToRemove.material)) {
            //             meshToRemove.material.forEach(material => material.dispose());
            //         } else {
            //             meshToRemove.material.dispose();
            //         }
            //     }

            //     // Opcional: limpe outras propriedades, como texturas, se aplicável
            // }
        },
        toggleTeethOpacity() {
            const teeth = this.findTeethInScene();

            teeth.forEach(tooth => {

                if (tooth.visible && tooth.material.opacity === 1) {
                    tooth.material.opacity = 0.5;
                }

                else if (tooth.visible && tooth.material.opacity === 0.5) {
                    tooth.visible = false;
                }

                else if (!tooth.visible) {
                    tooth.visible = true;
                    tooth.material.opacity = 1;
                }

                tooth.material.transparent = true;
                tooth.material.needsUpdate = true;
            });

        },
        adjustTeethOpacity() {
            const teeth = this.findTeethInScene();

            teeth.forEach(tooth => {
                // Verifica se o dente é o dente selecionado
                if (this.selectedTooth && tooth.userData.toothNumber === this.selectedTooth) {
                    tooth.material.opacity = 0.80; // Mantém a opacidade total para o dente selecionado
                    //this.activeObject = tooth;
                } else {
                    tooth.material.opacity = 0.15; // Torna os outros dentes semi-transparentes
                }
                tooth.material.transparent = true; // Garante que a transparência seja ativada
                tooth.material.needsUpdate = true; // Informa ao Three.js para atualizar o material do dente
            });

            // Se nenhum dente estiver selecionado, restaura a opacidade de todos os dentes
            if (!this.selectedTooth) {
                teeth.forEach(tooth => {
                    tooth.material.opacity = 1; // Restaura a opacidade total
                    tooth.material.needsUpdate = true;
                });
            }
        },
        findTeethInScene(arch = '') {
            const teeth = [];
            this.scene.traverse(child => {
                if (child.userData.objectType === 'tooth') {
                    const toothNumber = child.userData.toothNumber;
                    if ((arch === '') ||
                        (arch === 'upper' && toothNumber < 31) ||
                        (arch === 'lower' && toothNumber >= 31))
                        teeth.push(child);
                }
            });
            return teeth;
        },
        createOrderedEdgePath(vertices, vertexToEdgesMap) {
            let orderedVertices = [];
            let currentVertex = vertices[0];
            orderedVertices.push(currentVertex);

            let visitedVertices = new Set();
            visitedVertices.add(`${currentVertex.x},${currentVertex.y},${currentVertex.z}`);

            while (orderedVertices.length < vertices.length) {
                let vertexKey = `${currentVertex.x},${currentVertex.y},${currentVertex.z}`;
                let edges = vertexToEdgesMap.get(vertexKey);

                if (!edges) {
                    console.error('No edges found for vertex:', vertexKey);
                    break;
                }

                let nextVertexKey = edges.filter(v => !visitedVertices.has(v))
                    .sort((a, b) => {
                        let aCoords = a.split(',').map(Number);
                        let bCoords = b.split(',').map(Number);
                        let aVertex = new THREE.Vector3(...aCoords);
                        let bVertex = new THREE.Vector3(...bCoords);
                        return currentVertex.distanceToSquared(aVertex) - currentVertex.distanceToSquared(bVertex);
                    })[0];

                if (!nextVertexKey) break; // Se não houver próximo vértice, interrompe o loop

                let nextVertexCoords = nextVertexKey.split(',').map(Number);
                let nextVertex = new THREE.Vector3(...nextVertexCoords);

                orderedVertices.push(nextVertex);
                visitedVertices.add(nextVertexKey);
                currentVertex = nextVertex;
            }

            return orderedVertices;
        },
        createVertexToEdgeMap(edgesGeometry) {
            const vertexToEdgeMap = new Map();
            const positionAttribute = edgesGeometry.attributes.position;
            const vertices = positionAttribute.array;

            // Como EdgesGeometry não possui índices, assumimos que cada par de pontos forma uma aresta
            for (let i = 0; i < vertices.length; i += 6) {
                const vertex1Key = `${vertices[i]},${vertices[i + 1]},${vertices[i + 2]}`;
                const vertex2Key = `${vertices[i + 3]},${vertices[i + 4]},${vertices[i + 5]}`;

                // Adiciona a aresta para o vértice 1
                if (!vertexToEdgeMap.has(vertex1Key)) {
                    vertexToEdgeMap.set(vertex1Key, new Set());
                }
                vertexToEdgeMap.get(vertex1Key).add(vertex2Key);

                // Adiciona a aresta para o vértice 2
                if (!vertexToEdgeMap.has(vertex2Key)) {
                    vertexToEdgeMap.set(vertex2Key, new Set());
                }
                vertexToEdgeMap.get(vertex2Key).add(vertex1Key);
            }

            // Convertendo os sets para arrays
            for (let [vertexKey, edgeSet] of vertexToEdgeMap) {
                vertexToEdgeMap.set(vertexKey, Array.from(edgeSet));
            }

            return vertexToEdgeMap;
        },
        drawImageInDiv(image2D, divId, clear = true) {
            // Obter o tamanho da imagem
            const width = image2D[0].length;
            const height = image2D.length;

            // Criar um elemento canvas
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            // Obter o contexto 2D do canvas
            const ctx = canvas.getContext('2d');

            // Criar uma ImageData para o canvas
            const imageData = ctx.createImageData(width, height);
            const data = imageData.data;

            // Preencher o ImageData com os dados da matriz image2D
            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const index = (y * width + x) * 4; // Índice no array data
                    const intensity = image2D[y][x];  // Intensidade do pixel

                    if (intensity !== 255) {
                        // Mapear a intensidade para uma cor (de azul a vermelho)
                        let red = Math.floor(intensity);        // Mais intensidade -> mais vermelho
                        let green = Math.floor(intensity) * 0.25;                          // Sem contribuição de verde
                        let blue = Math.floor(255 - intensity); // Menos intensidade -> mais azul

                        if (intensity < 200) {
                            red = Math.floor(intensity);
                            green = Math.floor(intensity);
                            blue = Math.floor(intensity);
                        }

                        // Definir o pixel com a cor calculada
                        data[index] = red;       // Red
                        data[index + 1] = green; // Green
                        data[index + 2] = blue;  // Blue
                        data[index + 3] = 255;   // Alpha (opacidade)
                    } else {
                        // Definir o pixel com a cor calculada
                        data[index] = 255;       // Red
                        data[index + 1] = 255; // Green
                        data[index + 2] = 255;  // Blue
                        data[index + 3] = 255;   // Alpha (opacidade)
                    }
                }
            }

            // Desenhar o ImageData no canvas
            ctx.putImageData(imageData, 0, 0);

            // Inserir o canvas na div com o ID especificado
            const div = document.getElementById(divId);
            if (clear) div.innerHTML = ''; // Limpar conteúdo anterior (se houver)
            div.appendChild(canvas);
        },
        generate2DProjection(meshes, isUpper = false) {
            // Configurações iniciais
            const width = 240;   // Largura da imagem 2D
            const height = 240;  // Altura da imagem 2D

            // Criar uma matriz para representar a imagem 2D (preenchida inicialmente com 255)
            let image2D = new Array(height).fill(255).map(() => new Array(width).fill(255));

            // Função para converter coordenadas do mundo 3D (X, Z) para coordenadas de pixels (u, v)
            function worldToImageCoords(x, z, minX, maxX, minZ, maxZ) {
                const u = Math.floor(((x - minX) / (maxX - minX)) * (width - 1));
                let v = Math.floor(((z - minZ) / (maxZ - minZ)) * (height - 1));
                if (isUpper) {
                    // Inverter a coordenada Z se a arcada for superior
                    v = height - 1 - v;
                }
                return { u, v };
            }

            let minX = Infinity, maxX = -Infinity;
            let minZ = Infinity, maxZ = -Infinity;
            let minY = Infinity, maxY = -Infinity;

            // Primeiro, encontrar os limites dos meshes (bounding box)
            meshes.forEach(mesh => {
                const position = mesh.geometry.attributes.position.array;
                for (let i = 0; i < position.length; i += 3) {
                    const x = position[i] + mesh.position.x;
                    const y = position[i + 1] + mesh.position.y;
                    const z = position[i + 2] + mesh.position.z;
                    if (x < minX) minX = x;
                    if (x > maxX) maxX = x;
                    if (y < minY) minY = y;
                    if (y > maxY) maxY = y;
                    if (z < minZ) minZ = z;
                    if (z > maxZ) maxZ = z;
                }
            });

            // Agora, projetar cada vértice na matriz 2D
            meshes.forEach(mesh => {
                const position = mesh.geometry.attributes.position.array;
                for (let i = 0; i < position.length; i += 3) {
                    const x = position[i] + mesh.position.x;
                    const y = position[i + 1] + mesh.position.y;  // Altura
                    let z = position[i + 2] + mesh.position.z;

                    // Converter coordenadas 3D para 2D (X, Z -> u, v)
                    const { u, v } = worldToImageCoords(x, z, minX, maxX, minZ, maxZ);

                    // Usar a altura (Y) para determinar a cor/intensidade
                    const intensity = (isUpper)
                        ? Math.floor((maxY - y) / (maxY - minY) * 255)  // Inverter a intensidade para a arcada superior
                        : Math.floor((y - minY) / (maxY - minY) * 255);  // Manter a lógica normal para a arcada inferior


                    // Atualizar o pixel na imagem 2D
                    image2D[v][u] = Math.min(image2D[v][u], intensity);  // Evitar sobrescrever com valores menores
                }
            });

            return image2D;
        },
        tooth3DReconstruction__(activeGeometry, toothData) {
            // Cria a geometria de borda a partir da geometria ativa
            const edges = new THREE.EdgesGeometry(activeGeometry, 90);
            const positionsArray = edges.attributes.position.array;

            // Converte o array plano em um array de vetores Vector3
            let vertices = [];
            for (let i = 0; i < positionsArray.length; i += 3) {
                vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
            }

            // Obtém vértices únicos
            const uniqueVertices = this.uniqueVerticesFunction(vertices);

            // Calcula o centro de massa dos vértices únicos
            const centerOfMass = new THREE.Vector3();
            uniqueVertices.forEach(vertex => centerOfMass.add(vertex));
            centerOfMass.divideScalar(uniqueVertices.length);

            const orderedVertices = this.connectEdgePoints(uniqueVertices);

            // Cria a esfera para visualizar o centro de massa
            const centerSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
            const centerSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
            const centerSphere = new THREE.Mesh(centerSphereGeometry, centerSphereMaterial);
            centerSphere.position.copy(centerOfMass);

            let arcType = (this.activeObject.userData.modelType === 'mandibular') ? 'lower' : 'upper';
            let distance = this.findLargestDistanceWithFixedHeight(vertices, arcType);

            toothData.centerOfMass = centerOfMass.clone();
            toothData.orderedVertices = orderedVertices;
            toothData.distance = distance.largestDistance;
            if (!toothData.medial) toothData.medial = distance.point1;
            if (!toothData.distal) toothData.distal = distance.point2;

            // Verifica se a geometria ativa tem um atributo normal
            if (activeGeometry.attributes.normal) {
                const normals = activeGeometry.attributes.normal.array;
                let averageNormal = new THREE.Vector3(0, 0, 0);

                // Soma todas as normais para encontrar a média
                for (let i = 0; i < normals.length; i += 3) {
                    averageNormal.add(new THREE.Vector3(normals[i], normals[i + 1], normals[i + 2]));
                }

                // Normaliza a média
                averageNormal.divideScalar(normals.length / 3).normalize();

                toothData.averageNormal = averageNormal.clone();

                // Calcula a direção oposta
                const oppositeDirection = averageNormal.negate();

                // Define a distância de deslocamento
                const displacementDistance = 4;

                // Calcula o centro de massa deslocado
                const displacedCenterOfMass = new THREE.Vector3(
                    centerSphere.position.x + oppositeDirection.x * displacementDistance,
                    centerSphere.position.y + oppositeDirection.y * displacementDistance,
                    centerSphere.position.z + oppositeDirection.z * displacementDistance
                );

                // Visualiza o centro de massa deslocado com uma esfera amarela
                const displacedSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
                const displacedSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
                const displacedSphere = new THREE.Mesh(displacedSphereGeometry, displacedSphereMaterial);
                displacedSphere.position.copy(displacedCenterOfMass);

                // Agora, passamos os dados para a triangulação Delaunay
                // Você precisará implementar ou chamar a função de triangulação delaunay aqui
                const delaunayGeometry = this.createDelaunayGeometry(orderedVertices, displacedCenterOfMass);

                // Retorna a geometria criada pelo Delaunay
                return delaunayGeometry;
            }
        },
        tooth3DReconstruction(activeGeometry, toothData) {

            // Create edge geometry from the active object's geometry
            const edges = new THREE.EdgesGeometry(activeGeometry, 90);
            const positionsArray = edges.attributes.position.array;

            // Convert the flat array into an array of Vector3
            let vertices = [];
            for (let i = 0; i < positionsArray.length; i += 3) {
                vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
            }

            // Obtain unique vertices
            const uniqueVertices = this.uniqueVerticesFunction(vertices);

            // Calculate the center of mass of the unique vertices
            const centerOfMass = new THREE.Vector3();
            uniqueVertices.forEach(vertex => centerOfMass.add(vertex));
            centerOfMass.divideScalar(uniqueVertices.length);

            const orderedVertices = this.connectEdgePoints(uniqueVertices);

            // Visualize the center of mass with a yellow sphere
            const centerSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
            const centerSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
            const centerSphere = new THREE.Mesh(centerSphereGeometry, centerSphereMaterial);
            centerSphere.position.copy(centerOfMass);

            let arcType = (this.activeObject.userData.modelType === 'mandibular') ? 'lower' : 'upper';
            let distance = this.findLargestDistanceWithFixedHeight(vertices, arcType);

            toothData.centerOfMass = centerOfMass.clone();
            toothData.orderedVertices = orderedVertices;
            toothData.distance = distance.largestDistance;
            if (!toothData.medial) toothData.medial = distance.point1;
            if (!toothData.distal) toothData.distal = distance.point2;

            // Ensure the active object's geometry has a normal attribute
            if (activeGeometry.attributes.normal) {
                const normals = activeGeometry.attributes.normal.array;
                let averageNormal = new THREE.Vector3(0, 0, 0);

                // Sum all normals to find the average
                for (let i = 0; i < normals.length; i += 3) {
                    averageNormal.add(new THREE.Vector3(normals[i], normals[i + 1], normals[i + 2]));
                }

                // Normalize to get the average direction
                averageNormal.divideScalar(normals.length / 3).normalize();

                toothData.averageNormal = averageNormal.clone();

                // Calculate the opposite direction
                const oppositeDirection = averageNormal.negate();

                // Set the displacement distance
                const displacementDistance = 4;

                // Calculate the displaced center of mass
                const displacedCenterOfMass = new THREE.Vector3(
                    centerSphere.position.x + oppositeDirection.x * displacementDistance,
                    centerSphere.position.y + oppositeDirection.y * displacementDistance,
                    centerSphere.position.z + oppositeDirection.z * displacementDistance
                );

                // Visualize the displaced center of mass with a yellow sphere
                const displacedSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
                const displacedSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
                const displacedSphere = new THREE.Mesh(displacedSphereGeometry, displacedSphereMaterial);
                displacedSphere.position.copy(displacedCenterOfMass);

                const seam3D = this.create3DSeamDelaunay(orderedVertices, orderedVertices.map(() => displacedCenterOfMass.clone()));
                seam3D.computeVertexNormals();

                const seams3D = this.mergeGeometries([activeGeometry, seam3D]);
                return seams3D
            }
        },
        tooth3DReconstruction_(activeGeometry, toothData, toothNumber) {
            // Obter os vértices da activeGeometry
            const activePositionsArray = activeGeometry.attributes.position.array;
            let activeVertices = [];
            for (let i = 0; i < activePositionsArray.length; i += 3) {
                activeVertices.push(new THREE.Vector3(activePositionsArray[i], activePositionsArray[i + 1], activePositionsArray[i + 2]));
            }

            // Create edge geometry from the active object's geometry
            const edges = new THREE.EdgesGeometry(activeGeometry, 90);
            const edgePositionsArray = edges.attributes.position.array;

            // Convert the flat array into an array of Vector3
            let edgeVertices = [];
            for (let i = 0; i < edgePositionsArray.length; i += 3) {
                edgeVertices.push(new THREE.Vector3(edgePositionsArray[i], edgePositionsArray[i + 1], edgePositionsArray[i + 2]));
            }

            // Obtain unique vertices from edges
            const uniqueEdgeVertices = this.uniqueVerticesFunction(edgeVertices);

            // Calculate the center of mass of the unique edge vertices
            const centerOfMass = new THREE.Vector3();
            uniqueEdgeVertices.forEach(vertex => centerOfMass.add(vertex));
            centerOfMass.divideScalar(uniqueEdgeVertices.length);

            // Order edge vertices to form a connected edge path
            const orderedEdgeVertices = this.connectEdgePoints(uniqueEdgeVertices);

            // Visualize the center of mass with a yellow sphere
            const centerSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
            const centerSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
            const centerSphere = new THREE.Mesh(centerSphereGeometry, centerSphereMaterial);
            centerSphere.position.copy(centerOfMass);

            let arcType = (this.activeObject.userData.modelType === 'mandibular') ? 'lower' : 'upper';
            let distance = this.findLargestDistanceWithFixedHeight(edgeVertices, arcType);

            this.dentalMap[toothNumber].centerOfMass = centerOfMass.clone();
            this.dentalMap[toothNumber].orderedVertices = orderedEdgeVertices;
            this.dentalMap[toothNumber].distance = distance.largestDistance;
            if (!this.dentalMap[toothNumber].medial) this.dentalMap[toothNumber].medial = distance.point1;
            if (!this.dentalMap[toothNumber].distal) this.dentalMap[toothNumber].distal = distance.point2;

            // Ensure the active object's geometry has a normal attribute
            if (activeGeometry.attributes.normal) {
                const normals = activeGeometry.attributes.normal.array;
                let averageNormal = new THREE.Vector3(0, 0, 0);

                // Sum all normals to find the average
                for (let i = 0; i < normals.length; i += 3) {
                    averageNormal.add(new THREE.Vector3(normals[i], normals[i + 1], normals[i + 2]));
                }

                // Normalize to get the average direction
                averageNormal.divideScalar(normals.length / 3).normalize();

                this.dentalMap[toothNumber].averageNormal = averageNormal.clone();

                // Calculate the opposite direction
                const oppositeDirection = averageNormal.negate();

                // Set the displacement distance
                const displacementDistance = 4;

                // Calculate the displaced center of mass
                const displacedCenterOfMass = new THREE.Vector3(
                    centerSphere.position.x + oppositeDirection.x * displacementDistance,
                    centerSphere.position.y + oppositeDirection.y * displacementDistance,
                    centerSphere.position.z + oppositeDirection.z * displacementDistance
                );

                // Visualize the displaced center of mass with a yellow sphere
                const displacedSphereGeometry = new THREE.SphereGeometry(0.2, 32, 32);
                const displacedSphereMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
                const displacedSphere = new THREE.Mesh(displacedSphereGeometry, displacedSphereMaterial);
                displacedSphere.position.copy(displacedCenterOfMass);

                // Combine original vertices, edge vertices, and the displaced center of mass for Delaunay triangulation
                const delaunayVertices = activeVertices.concat(orderedEdgeVertices).concat([displacedCenterOfMass]);
                const seam3D = this.createDelaunayGeometry(delaunayVertices);
                seam3D.computeVertexNormals();

                return seam3D;
            }
        },
        createDelaunayGeometry(vertices) {
            // Convert Vector3 vertices to an array of points for Delaunay
            const points = vertices.map(vertex => [vertex.x, vertex.y, vertex.z]);

            // Perform Delaunay triangulation
            const delaunay = Delaunator.from(points);
            const geometry = new THREE.BufferGeometry();

            // Create vertices array for BufferGeometry
            const flatVertices = [];
            points.forEach(point => {
                flatVertices.push(point[0], point[1], point[2]);
            });

            // Create faces (triangles) from Delaunay triangulation
            const indices = [];
            for (let i = 0; i < delaunay.triangles.length; i += 3) {
                indices.push(delaunay.triangles[i], delaunay.triangles[i + 1], delaunay.triangles[i + 2]);
            }

            // Set vertices and indices to geometry
            geometry.setIndex(indices);
            geometry.setAttribute('position', new THREE.Float32BufferAttribute(flatVertices, 3));

            return geometry;
        },
        findClosestVertexGums(toothVertex, gums) {
            let closestGumVertex = null;
            let shortestDistance = Infinity;

            // Supondo que gums seja uma coleção ou um único objeto de malha
            // Se gums for uma coleção, você precisaria iterar sobre ela

            // Aqui, assumimos gums como um único objeto Mesh para simplificar
            const vertices = gums.geometry.attributes.position.array;
            const gumWorldMatrix = gums.matrixWorld; // A matriz de transformação mundial da gengiva

            for (let i = 0; i < vertices.length; i += 3) {
                // Cria um Vector3 para o vértice atual na gengiva
                let gumVertex = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);

                // Converte o vértice da gengiva para o espaço mundial
                gumVertex.applyMatrix4(gumWorldMatrix);

                // Calcula a distância entre o vértice do dente (já no espaço mundial) e o vértice atual da gengiva
                let distance = toothVertex.distanceTo(gumVertex);

                // Se for a distância mais curta até agora, armazena este vértice e distância
                if (distance < shortestDistance) {
                    shortestDistance = distance;
                    closestGumVertex = gumVertex; // Aqui, gumVertex já está no espaço mundial
                }
            }

            return closestGumVertex;
        },
        makeTeethGumsLines() {
            const gums = this.findGumInScene(); // Supõe que já tenha o objeto da gengiva
            const teeth = this.findTeethInScene(); // Supõe que retorna um array de objetos dentes

            // Criar um BufferGeometry para armazenar as linhas
            let linesGeometry = new THREE.BufferGeometry();
            let positions = [];

            // Processar cada dente
            teeth.forEach(tooth => {

                // Criar edgeGeometry para cada dente
                const edgeGeometry = new THREE.EdgesGeometry(tooth.geometry, 90);
                const positionsArray = edgeGeometry.attributes.position.array;

                // Converter o array plano em um array de Vector3
                let vertices = [];
                for (let i = 0; i < positionsArray.length; i += 3) {
                    vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
                }

                const uniqueVertices = this.uniqueVerticesFunction(vertices); // Supõe que filtra vértices duplicados

                // Para cada vértice único no dente, encontrar o vértice mais próximo na gengiva
                uniqueVertices.forEach(toothVertex => {
                    toothVertex.applyMatrix4(tooth.matrixWorld);
                    let closestGumVertex = this.findClosestVertexGums(toothVertex, gums);

                    // Adicionar os pontos à lista de posições (linhas)
                    positions.push(toothVertex.x, toothVertex.y, toothVertex.z);
                    positions.push(closestGumVertex.x, closestGumVertex.y, closestGumVertex.z);
                });
            });

            // Cria atributo de posição para a geometria das linhas
            linesGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

            // Criar material e linha para visualização
            let lineMaterial = new THREE.LineBasicMaterial({ color: 0xffff00 });
            let lineMesh = new THREE.LineSegments(linesGeometry, lineMaterial);
            lineMesh.userData.name = 'teethGumsLines';

            // Remover mesh anterior se ele existir
            let existingLineMesh = this.scene.getObjectByName('teethGumsLines');
            if (existingLineMesh) {
                this.scene.remove(existingLineMesh);
            }

            // Adicionar linhas à cena
            this.scene.add(lineMesh);
        },
        getTeethGumsCloudPoints() {
            const gums = this.findGumInScene(); // Supõe que já tenha o objeto da gengiva
            const teeth = this.findTeethInScene(); // Supõe que retorna um array de objetos dentes

            let positions = [];

            // Processar cada dente
            teeth.forEach(tooth => {

                // Criar edgeGeometry para cada dente
                const edgeGeometry = new THREE.EdgesGeometry(tooth.geometry, 90);
                const positionsArray = edgeGeometry.attributes.position.array;

                // Converter o array plano em um array de Vector3
                let vertices = [];
                for (let i = 0; i < positionsArray.length; i += 3) {
                    vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
                }

                const uniqueVertices = this.uniqueVerticesFunction(vertices); // Supõe que filtra vértices duplicados

                // Para cada vértice único no dente, encontrar o vértice mais próximo na gengiva
                uniqueVertices.forEach(toothVertex => {
                    toothVertex.applyMatrix4(tooth.matrixWorld);
                    let closestGumVertex = this.findClosestVertexGums(toothVertex, gums);

                    // Adicionar os pontos à lista de posições (linhas)
                    positions.push(toothVertex.x, toothVertex.y, toothVertex.z);
                    positions.push(closestGumVertex.x, closestGumVertex.y, closestGumVertex.z);
                });
            });

            return positions;

        },
        findClosestVerticesGums(toothVertex, gums, numVertices = 3) {
            let distances = [];

            const vertices = gums.attributes.position.array;
            //const gumWorldMatrix = gums.matrixWorld;

            // Calcula as distâncias de todos os vértices da gengiva ao vértice do dente
            for (let i = 0; i < vertices.length; i += 3) {
                let gumVertex = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);
                //gumVertex.applyMatrix4(gumWorldMatrix);
                let distance = toothVertex.distanceTo(gumVertex);

                distances.push({ distance, gumVertex });
            }

            // Ordena pelo menor distância e pega os numVertices mais próximos
            distances.sort((a, b) => a.distance - b.distance);

            // Retorna apenas os vértices, sem as distâncias, dos numVertices mais próximos
            return distances.slice(0, numVertices).map(d => d.gumVertex);
        },
        makeDynamicGum() {
            const gums = this.findGumInScene(); // Supõe que já tenha o objeto da gengiva
            const teeth = this.findTeethInScene(); // Supõe que retorna um array de objetos dentes
            let dynamicGumGeometry = new THREE.BufferGeometry(); // Geometria acumuladora

            const gumsEdges = new THREE.EdgesGeometry(gums.geometry, 25);

            // Encontrar o grupo que contém as gengivas
            const dentalGroup = this.scene.children.find(child =>
                child.isGroup && child.children.some(obj => obj.userData.objectType === 'gums'));

            if (!dentalGroup) {
                console.error('Nenhum grupo adequado encontrado que contenha as gengivas.');
                return; // Ou criar um novo grupo, dependendo da necessidade.
            }

            // Verifica se dynamicGum já existe dentro do grupo
            let dynamicGum = dentalGroup.getObjectByName('dynamicGum');
            if (!dynamicGum) {
                dynamicGum = new THREE.Mesh(dynamicGumGeometry, new THREE.MeshPhongMaterial({
                    color: 0xffd0db, // 0xffc0cb
                    specular: 0x333366,
                    emissive: 0x000000,
                    shininess: 0,
                    side: THREE.DoubleSide,
                    transparent: true,
                    opacity: 1,
                    reflectivity: 0,
                }));
                dynamicGum.userData.name = 'dynamicGum';
                dynamicGum.userData.objectType = 'dynamic';
                dynamicGum.name = 'dynamicGum';
                dentalGroup.add(dynamicGum); // Adiciona ao grupo em vez de à cena
            } else {
                // Se existir, limpa a geometria existente para reuso
                dynamicGum.geometry.dispose();
                dynamicGum.geometry = dynamicGumGeometry;
            }

            let allGeometries = [];

            teeth.forEach(tooth => {
                let positions = []; // Reinicia para cada dente

                // Criar edgeGeometry para cada dente
                const edgeGeometry = new THREE.EdgesGeometry(tooth.geometry, 90);
                const positionsArray = edgeGeometry.attributes.position.array;

                // Converter o array plano em um array de Vector3
                let vertices = [];
                for (let i = 0; i < positionsArray.length; i += 3) {
                    vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
                }

                const uniqueVertices = this.uniqueVerticesFunction(vertices); // Supõe que filtra vértices duplicados

                // Para cada vértice único no dente, encontrar o vértice mais próximo na gengiva
                uniqueVertices.forEach(toothVertex => {
                    toothVertex.applyMatrix4(tooth.matrixWorld);
                    let closestGumVertex = this.findClosestVerticesGums(toothVertex, gumsEdges, 30);

                    // Processar cada vértice próximo retornado
                    closestGumVertex.forEach(closestGumVertex => {
                        // Adiciona o vértice do dente e o vértice da gengiva ao array positions
                        positions.push(toothVertex.x, toothVertex.y, toothVertex.z);
                        positions.push(closestGumVertex.x, closestGumVertex.y, closestGumVertex.z);
                    });
                });

                // Após coletar 'positions', converte para um array de THREE.Vector3
                let vectorArray = [];
                for (let i = 0; i < positions.length; i += 6) { // Incremento de 6 porque você adiciona dois vértices por vez (dente e gengiva)
                    vectorArray.push(new THREE.Vector3(positions[i], positions[i + 1], positions[i + 2]));
                    vectorArray.push(new THREE.Vector3(positions[i + 3], positions[i + 4], positions[i + 5]));
                }


                const geometry = this.delaunayTriangulation(vectorArray); // Supondo que esta função retorne uma BufferGeometry
                if (geometry) {
                    allGeometries.push(geometry);
                }
            });

            // Após processar todos os dentes, mescla todas as geometrias
            if (allGeometries.length > 0) {
                const mergedGeometry = BufferGeometryUtils.mergeGeometries(allGeometries, false);
                dynamicGum.geometry = mergedGeometry;
                dynamicGum.geometry.computeVertexNormals();
            }

        },
        findClosestVertexTeeth(gumVertex, teeth) {
            let closestVertex = null;
            let shortestDistance = Infinity;

            teeth.forEach(tooth => {
                const vertices = tooth.geometry.attributes.position.array;
                for (let i = 0; i < vertices.length; i += 3) {
                    // Create a Vector3 for the current vertex on the tooth
                    let toothVertex = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);

                    // Convert the tooth vertex to world space if necessary
                    toothVertex.applyMatrix4(tooth.matrixWorld);

                    // Calculate the distance between the gum vertex and the current tooth vertex
                    let distance = gumVertex.distanceTo(toothVertex);

                    // If it's the shortest distance so far, store this vertex and distance
                    if (distance < shortestDistance) {
                        shortestDistance = distance;
                        closestVertex = toothVertex;
                    }
                }
            });

            return { closestVertex: closestVertex, shortestDistance: shortestDistance };
        },
        makeGumsTeethLines() {
            const gums = this.findGumInScene();
            const teeth = this.findTeethInScene();

            const edgeGeometry = new THREE.EdgesGeometry(gums.geometry, 90);
            const positionsArray = edgeGeometry.attributes.position.array;

            // Convert the flat array into an array of Vector3
            let vertices = [];
            for (let i = 0; i < positionsArray.length; i += 3) {
                vertices.push(new THREE.Vector3(positionsArray[i], positionsArray[i + 1], positionsArray[i + 2]));
            }

            const uniqueVertices = this.uniqueVerticesFunction(vertices);

            // Criar um BufferGeometry para armazenar as linhas
            let linesGeometry = new THREE.BufferGeometry();
            let positions = [];

            // Para cada vértice único na gengiva, encontrar o vértice mais próximo em todos os dentes
            uniqueVertices.forEach(gumVertex => {
                const nearVertex = this.findClosestVertexTeeth(gumVertex, teeth);
                let closestToothVertex = nearVertex.closestVertex;

                if (nearVertex.shortestDistance < 3) {
                    // Adicionar os pontos à lista de posições (linhas)
                    positions.push(gumVertex.x, gumVertex.y, gumVertex.z);
                    positions.push(closestToothVertex.x, closestToothVertex.y, closestToothVertex.z);
                }

            });

            // Cria atributo de posição para a geometria das linhas
            linesGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

            // Criar material e linha para visualização
            let lineMaterial = new THREE.LineBasicMaterial({ color: 0xff0000 });
            let lineMesh = new THREE.LineSegments(linesGeometry, lineMaterial);
            lineMesh.userData.name = 'gumsTeethLines';

            // Remover mesh anterior se ele existir
            let existingLineMesh = this.scene.getObjectByName('gumsTeethLines');
            if (existingLineMesh) {
                this.scene.remove(existingLineMesh);
            }

            // Adicionar linhas à cena
            this.scene.add(lineMesh);

        },
        applyDelaunayTriangulation() {
            const gums = this.findGumInScene(); // Encontra a gengiva na cena

            // Extrai os vértices da geometria atual da gengiva
            //const edgeGeometry = new THREE.EdgesGeometry(gums.geometry,1);
            const verticesArray = gums.geometry.attributes.position.array;
            let vectorArray = [];
            for (let i = 0; i < verticesArray.length; i += 3) {
                vectorArray.push(new THREE.Vector3(verticesArray[i], verticesArray[i + 1], verticesArray[i + 2]));
            }

            // Remove vértices duplicados
            let uniqueVertices = this.uniqueVerticesFunction(vectorArray);

            // Converte os vértices únicos de volta para o formato [x, z], assegurando que são apenas números
            const points = uniqueVertices.reduce((acc, v) => {
                const x = parseFloat(v.x);
                const z = parseFloat(v.z);
                if (!isNaN(x) && !isNaN(z)) {
                    acc.push(x, z);
                }
                return acc;
            }, []);

            // Certifica-se de que todos os pontos são numéricos
            if (points.length > 0 && points.every(val => typeof val === 'number')) {
                try {
                    // Realiza a triangulação de Delaunay
                    const delaunay = new Delaunator(points);
                    const indices = delaunay.triangles; // Já é um Uint32Array

                    // Prepara um array de Float32Array para a nova geometria
                    const newVertices = [];
                    uniqueVertices.forEach(v => {
                        if (!isNaN(v.x) && !isNaN(v.y) && !isNaN(v.z)) {
                            newVertices.push(v.x, v.y, v.z);
                        }
                    });

                    // Cria uma nova geometria com os índices da triangulação
                    const newGeometry = new THREE.BufferGeometry();
                    newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(newVertices), 3));
                    newGeometry.setIndex(Array.from(indices)); // Transforma o Uint32Array em um array regular, se necessário
                    newGeometry.computeVertexNormals(); // Recalcula as normais para iluminação correta

                    // Atualiza a geometria do objeto de gengiva com a nova geometria
                    gums.geometry.dispose(); // Libera a memória da geometria antiga
                    gums.geometry = newGeometry;
                } catch (error) {
                    console.error('Erro ao aplicar triangulação de Delaunay:', error);
                }
            } else {
                console.error('Array de pontos contém valores não numéricos ou está vazio.');
            }
        },
        convertToDelaunayInput(vertices) {
            const points = [];
            vertices.forEach(v => {
                const x = parseFloat(v.x);
                const z = parseFloat(v.z); // Supondo que você queira usar x e z para a triangulação
                if (!isNaN(x) && !isNaN(z)) {
                    points.push(x, z);
                }
            });
            return points;
        },
        removeLargeTriangles(geometry, maxPerimeter) {
            const vertices = geometry.attributes.position.array;
            const indices = geometry.index.array;
            const newIndices = [];

            for (let i = 0; i < indices.length; i += 3) {
                const index1 = indices[i] * 3;
                const index2 = indices[i + 1] * 3;
                const index3 = indices[i + 2] * 3;

                const v1 = new THREE.Vector3(vertices[index1], vertices[index1 + 1], vertices[index1 + 2]);
                const v2 = new THREE.Vector3(vertices[index2], vertices[index2 + 1], vertices[index2 + 2]);
                const v3 = new THREE.Vector3(vertices[index3], vertices[index3 + 1], vertices[index3 + 2]);

                const perimeter = v1.distanceTo(v2) + v2.distanceTo(v3) + v3.distanceTo(v1);

                if (perimeter <= maxPerimeter) {
                    newIndices.push(indices[i], indices[i + 1], indices[i + 2]);
                }
            }

            geometry.setIndex(newIndices);
            geometry.computeVertexNormals(); // Recalculate normals if needed
        },
        removeLargeTrianglesRaycaster(geometry, maxPerimeter, dentalArchMesh) {
            const vertices = geometry.attributes.position.array;
            const indices = geometry.index.array;
            dentalArchMesh.geometry.computeBoundsTree();
            const newIndices = [];
            const raycaster = new THREE.Raycaster();
            raycaster.firstHitOnly = true;
            const directionDown = new THREE.Vector3(0, -1, 0);
            const directionUp = new THREE.Vector3(0, 1, 0);
            const centroid = new THREE.Vector3(); // Centróide reutilizável

            for (let i = 0; i < indices.length; i += 3) {
                const index1 = indices[i] * 3;
                const index2 = indices[i + 1] * 3;
                const index3 = indices[i + 2] * 3;

                const v1 = new THREE.Vector3(vertices[index1], vertices[index1 + 1], vertices[index1 + 2]);
                const v2 = new THREE.Vector3(vertices[index2], vertices[index2 + 1], vertices[index2 + 2]);
                const v3 = new THREE.Vector3(vertices[index3], vertices[index3 + 1], vertices[index3 + 2]);

                const perimeter = v1.distanceTo(v2) + v2.distanceTo(v3) + v3.distanceTo(v1);
                centroid.set((v1.x + v2.x + v3.x) / 3, (v1.y + v2.y + v3.y) / 3, (v1.z + v2.z + v3.z) / 3);

                if (perimeter > maxPerimeter) {
                    raycaster.set(centroid, directionDown);
                    let intersectsDown = raycaster.intersectObject(dentalArchMesh);
                    raycaster.set(centroid, directionUp);
                    let intersectsUp = raycaster.intersectObject(dentalArchMesh);

                    if (intersectsDown.length === 0 && intersectsUp.length === 0) {
                        continue; // Não adicionar ao novo índice
                    }
                }

                newIndices.push(indices[i], indices[i + 1], indices[i + 2]);
            }

            geometry.setIndex(newIndices);
            geometry.computeVertexNormals();
        },
        delaunayTriangulation(verticesArray) {
            const points = this.convertToDelaunayInput(verticesArray);

            if (points.length > 0 && points.every(val => typeof val === 'number')) {
                try {
                    const delaunay = new Delaunator(points);
                    const indices = delaunay.triangles;

                    const newVertices = [];
                    verticesArray.forEach(v => {
                        if (!isNaN(v.x) && !isNaN(v.y) && !isNaN(v.z)) {
                            newVertices.push(v.x, v.y, v.z);
                        }
                    });

                    const newGeometry = new THREE.BufferGeometry();
                    newGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(newVertices), 3));
                    newGeometry.setIndex(Array.from(indices));
                    //newGeometry.computeVertexNormals();

                    return newGeometry;
                } catch (error) {
                    console.error('Erro ao aplicar triangulação de Delaunay:', error);
                    return null;
                }
            } else {
                console.error('Array de pontos contém valores não numéricos ou está vazio.');
                return null;
            }
        },
        performAction(action) {
            console.table(action)
            switch (action) {
                case 'createDentalMesh':

                    this.executeActionWithLoading('createDentalMesh',
                        () => {
                            if (this.activeObject) {
                                const object = this.scene.children.find(child => child.uuid === this.activeObject.uuid);
                                object.visible = !object.visible;
                                //this.$refs.progressDialog.showProgressDialog("Aplicando reconhecimento por IA. Aguarde...", 10)
                                this.statusMessage = 'Processando Mesh Data...'
                                //setTimeout(() => { this.applyModelToMesh(true); }, 500)
                                //setTimeout(() => { this.loadAndCreateBorderInfoMeshSimple(); }, 500)
                                this.createDentalMeshGroup(this.dentalMap);
                                //this.scanDentalMapAndStartWorker() 
                            }
                        }, 250);
                    break;
                case 'toggleObjectVisibility':
                    if (this.activeObject) {
                        const object = this.scene.children.find(child => child.uuid === this.activeObject.uuid);
                        object.visible = !object.visible;
                        if (this.activeObject.isTransformControls) this.transformControl.detach();

                    }
                    break;
                case 'toggleGums': {
                    const gumsList = this.findGumsInScene(); // Isso agora é uma lista
                    const dynamicGumsList = this.findDynamicGumInScene(); // Supondo que isso também possa ser uma lista

                    // Verifica se a lista de gengivas não está vazia
                    if (gumsList.length) {
                        gumsList.forEach(gums => {
                            // Se os gums estiverem visíveis e com opacidade total, torná-los semi-transparentes
                            if (gums.visible && gums.material.opacity === 1) {
                                gums.material.opacity = 0.5;
                            }
                            // Se os gums estiverem visíveis e semi-transparentes, torná-los invisíveis
                            else if (gums.visible && gums.material.opacity === 0.5) {
                                gums.visible = false;
                            }
                            // Se os gums estiverem invisíveis, torná-los visíveis com opacidade total
                            else if (!gums.visible) {
                                gums.visible = true;
                                gums.material.opacity = 1;
                            }
                            gums.material.needsUpdate = true; // Garante que o Three.js atualize o material
                        });

                        // Aplicar a mesma lógica para gengivas dinâmicas, se existirem
                        if (dynamicGumsList && dynamicGumsList.length) {
                            dynamicGumsList.forEach(dynamic => {
                                // A lógica aqui simplesmente sincroniza o estado das gengivas dinâmicas com o das gengivas normais
                                // Isso presume que a lista de gengivas dinâmicas corresponde à lista de gengivas normais
                                dynamic.visible = gumsList[0].visible; // Usa o estado de visibilidade do primeiro elemento como referência
                                dynamic.material.opacity = gumsList[0].material.opacity; // Usa a opacidade do primeiro elemento como referência
                                dynamic.material.needsUpdate = true;
                            });
                        }
                    }
                }
                    break;

                case 'toggleTeeth':
                    this.toggleTeethOpacity()
                    break;
                case 'saveBorderInfo':
                    this.saveAnalyzedSphereData()
                    break;
                case 'loadBorderInfo':
                    this.loadAndCreateBorderInfoMesh()
                    break;
                case 'applyChanges':
                    this.executeActionWithLoading('saveActiveObject',
                        () => this.commitTransform(), 250);
                    break;
                case 'clearTasks':
                    this.$store.dispatch('editor3D/clearTasks');
                    break;
                case 'loadSegmentation':
                    this.executeActionWithLoading('loadSegmentation',
                        () => { this.fetchFileList(); }, 500);
                    break;
                case 'saveSegmentation':
                    this.executeActionWithLoading('saveSegmentation',
                        () => this.dbSaveDentalMap(this.activeObject.userData.modelId, this.dentalMap), 1000);
                    break;
                case 'extractToothBorder':
                    this.iaActive = "orange";
                    this.executeActionWithLoading('extractToothBorder',
                        () => this.executeRaycasting(), 1000);
                    break;
                case 'saveActiveObject':
                    this.executeActionWithLoading('saveActiveObject',
                        () => this.exportSTL(), 1000);
                    break;
                case 'showDentalArch':
                    this.executeActionWithLoading('showDentalArch',
                        () => {
                            this.createBoundingBoxMeshForTeeth();
                            this.drawDentalArch();
                            //this.preAlignDentalMap(this.dentalMap)
                            //this.identifyCusps(this.dentalMap);
                            //this.createToothHeightMap()
                            //this.createHeatMapBasedOnCentersOfMass()
                            //this.createCuspHeightMap()
                            //this.closeGapsBetweenTeethAndGum()
                        }, 1000);
                    break;
                case 'startSES':
                    this.executeActionWithLoading('startSES',
                        () => this.startSESAction(), 1000);
                    break;
                case 'dynamicGum': {
                    //this.makeGumsTeethLines();
                    //this.makeTeethGumsLines();
                    //this.applyDelaunayTriangulation();
                    //this.newMakeDynamicGum();
                    //this.createToothBorders(this.dentalMap);
                    this.closeGapsBetweenTeethAndGum();
                    break;
                }
                case 'toggleArchMoveType':
                    this.executeActionWithLoading('toggleArchMoveType',
                        () => this.toggleArchMoveType(), 100);
                    break;
                case 'clearContourPoints':
                    this.clearContourPoints();
                    break;
                case 'toggleContourMarking':
                    this.toggleContourMarking();
                    break;
                case 'applyCutBelow':
                    this.executeActionWithLoading('cutModel',
                        () => this.cutActiveObject(false), 1000);
                    break;
                case 'applyCutAbove':
                    this.executeActionWithLoading('cutModel',
                        () => this.cutActiveObject(true), 1000);
                    break;
                case 'cutModel':
                    this.executeActionWithLoading('cutModel',
                        () => this.cloneOcclusionPlanForCutting(), 1000);
                    break;
                case 'creatingOcclusionPlan':
                    this.executeActionWithLoading('creatingOcclusionPlan',
                        () => this.initiateOcclusionPlan(), 1000);
                    break;
                case 'creatingDentalArch':
                    this.executeActionWithLoading('creatingDentalArch',
                        () => this.initiateDentalArch(), 1000);
                    break;
                case 'toggleUpperJaw':
                    this.toggleJaw('maxillary');
                    this.toggleJawVisibility(true, false, false)
                    break;
                case 'toggleLowerJaw':
                    this.toggleJaw('mandibular');
                    this.toggleJawVisibility(false, true, false)
                    break;
                case 'toggleJaw':
                    this.toggleJawVisibility(true, true, false)
                    break;
                case 'playAnimation':
                    this.animateToOriginal();
                    break;
                case 'pauseAnimation':
                    this.pauseAnimation();
                    break;
                case 'resetAnimation':
                    this.resetAnimation();
                    break;
                case 'createPlan':
                    this.generateTreatmentPlanFromCurrentState();
                    break;
                case 'alignModel':
                    this.rotateAllMeshesToXZ();
                    break;
                case 'plotPivotLines':
                    this.addPivotLinesForAllTeeth();
                    break;
                case 'viewFront':
                    this.alignCameraToAxis('Z');
                    break;
                case 'viewBack':
                    this.alignCameraToAxis('-Z');
                    break;
                case 'viewRight':
                    this.alignCameraToAxis('X');
                    break;
                case 'viewLeft':
                    this.alignCameraToAxis('-X');
                    break;
                case 'viewTop':
                    this.alignCameraToAxis('Y');
                    break;
                case 'viewBottom':
                    this.alignCameraToAxis('-Y');
                    break;
                case 'toggleLight':
                    this.toggleLight('ambient');
                    break;
                case 'toggleLightDir1':
                    this.toggleLight('directional1');
                    break;
                case 'toggleLightDir2':
                    this.toggleLight('directional2');
                    break;
                case 'toggleBoxHelper':
                    if (!this.activeObject.isTransformControls) {
                        if (this.activeObject !== this.transformControl.object)
                            this.transformControl.attach(this.activeObject)
                        else
                            this.transformControl.detach()
                    } else
                        this.transformControl.detach()

                    //this.toggleBoxHelper();
                    break;
                case 'controlTranslate':
                    this.transformControl.setMode('translate');
                    break;
                case 'controlRotate':
                    this.transformControl.setMode('rotate');
                    break;
            }
        },
        toggleArchMoveType() {
            const moveTypes = ['fullArch', 'ends', 'midPoints', 'centerPoint', 'endsLeft', 'midPointsLeft', 'endsRight', 'midPointsRight'];
            let currentIndex = moveTypes.indexOf(this.activeArchMoveType);
            currentIndex = (currentIndex + 1) % moveTypes.length; // Avança para o próximo tipo e volta ao primeiro após o último.
            this.activeArchMoveType = moveTypes[currentIndex];
            this.statusMessage = this.$t(this.activeArchMoveType);
        },
        clearContourPoints() {
            this.$store.dispatch('editor3D/clearContourPoints');
            // Adicionalmente, você pode querer atualizar a cena aqui se necessário
            this.updateContour();
        },
        toggleContourMarking() {
            const currentAction = this.$store.state.editor3D.currentAction;
            if (currentAction === 'markingContour') {
                // Se já estiver no estado de marcação, finalizar o processo
                this.$store.dispatch('editor3D/finishMarkingContour');
            } else {
                // Se não estiver, iniciar o processo de marcação
                this.$store.dispatch('editor3D/startMarkingContour');
            }
        },
        updateContour() {
            const contourPoints = this.$store.getters['editor3D/contourPoints'];
            const isContour = (this.currentAction !== 'creatingDentalArch');

            // Encontrar ou criar o objeto de contorno na cena
            let contourObject = this.scene.children.find(child => child.userData.isContour === true);
            if (!contourObject) {
                contourObject = new THREE.Group();
                contourObject.userData = { name: "Countour", isContour: true };
                this.scene.add(contourObject);
            } else {
                // Limpar os objetos de contorno existentes
                while (contourObject.children.length) {
                    const child = contourObject.children[0];
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) child.material.dispose();
                    contourObject.remove(child);
                }
            }

            // Criar esferas para os pontos de contorno
            contourPoints.forEach((point, index, array) => {
                const color = (isContour) ? (index === array.length - 1 ? 0xffa0a0 : 0xff2626) : 0x2626ff;
                this.addSphereAtPoint(point, contourObject, index, color, isContour);
            });

            // Criar linhas para conectar os pontos de contorno
            if (isContour)
                this.addLinesBetweenPoints(contourPoints, contourObject, isContour);
            else
                this.addLinesBetweenPoints(contourPoints, contourObject, isContour, 0.5, 0xff2626);
        },
        addPlaneSphereAtPoint(point) {
            const geometry = new THREE.SphereGeometry(0.75, 32, 32); // Tamanho da esfera ajustável conforme necessário
            const material = new THREE.MeshPhongMaterial({ color: 0xffA726, specular: 0x222222, shininess: 400, side: THREE.DoubleSide })
            const sphere = new THREE.Mesh(geometry, material);

            sphere.position.copy(point);
            sphere.userData = { helper: true, hide: true }; // Marca a esfera como auxiliar e oculta na lista da cena

            this.scene.add(sphere);
        },
        addSphereAtPoint(point, parent, pointIndex, color = 0xff2626, isContour = true) {
            const sphereSize = (isContour) ? 0.4 : 1;
            const sphereGeometry = new THREE.SphereGeometry(sphereSize, 12, 12);
            const sphereMaterial = new THREE.MeshPhongMaterial({ color: color, specular: 0x222222, shininess: 500, side: THREE.DoubleSide })
            const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);

            // Define o userData para o Mesh da esfera
            sphere.userData = { isContourSphere: true, pointIndex: pointIndex };

            sphere.position.copy(point);
            parent.add(sphere);
        },
        onDocumentMouseDown(event) {
            // Verifica se o botão esquerdo do mouse (botão 0) foi pressionado
            if (event.button === 0 && this.$store.state.editor3D.currentAction === 'smoothingEdges') {
                this.isMouseDown = true;
            }
            if (event.button === 0) {
                const intersection = this.getPointOnModel(event);

                // Verifique se você clicou em uma esfera de contorno
                if (intersection && intersection.objectRef.userData.isContourSphere) {
                    this.isDragging = true;
                    this.selectedSphere = intersection.objectRef;
                    // Desativar os controles de câmera se você os tem habilitado
                    // this.controls.enabled = false;
                    event.preventDefault(); // Isso evita outros manipuladores que possam interferir
                }
            }

            if (event.button === 2) { // Botão direito do mouse
                event.preventDefault(); // Evitar o comportamento padrão (rotação)
                this.mouseDownPosition = { x: event.clientX, y: event.clientY };
                this.lastMousePosition = { x: event.clientX, y: event.clientY };
            }

            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            // Verifique se o mousedown ocorreu em um objeto controlado pelo transformControl
            let raycaster = new THREE.Raycaster();

            // Configura o raycaster a partir da câmera e da posição do mouse
            raycaster.setFromCamera(this.mouse, this.camera);

            const intersects = raycaster.intersectObject(this.transformControl, true);
            if (intersects.length > 0) {
                this.transformControl.children.forEach(child => {
                    if (child.type === 'TransformControlsGizmo') {
                        child.visible = true;
                    }
                });
            }
        },
        onDocumentMouseMove(event) {
            if (event.shiftKey && event.buttons === 1) {
                const borderInfo = this.scene.getObjectByName("borderInfo") || null;
                const intersection = this.getPointOnModel(event, borderInfo);
                this.createTranslucentSphere(
                    intersection.point,
                    0.25,
                    0x00ff00,
                    0.5
                );
            } else if (event.altKey && event.buttons === 1) {
                // Lógica para "borracha" removendo esferas dentro de um raio
                const borderInfo = this.scene.getObjectByName("borderInfo");
                if (borderInfo && borderInfo.children.length > 0) {
                    const intersection = this.getPointOnModel(event, borderInfo);

                    // Definindo o raio para remoção (0.25 no exemplo)
                    const removalRadius = 0.25;

                    // Array temporário para armazenar esferas a serem removidas
                    const spheresToRemove = [];

                    // Loop por cada esfera no grupo "borderInfo"
                    borderInfo.children.forEach(sphere => {
                        // Calcular a distância entre o ponto da esfera e o ponto de interseção
                        const distance = intersection.point.distanceTo(sphere.position);

                        // Verificar se a esfera está dentro do raio
                        if (distance <= removalRadius) {
                            spheresToRemove.push(sphere);
                        }
                    });

                    // Remover todas as esferas no array temporário
                    spheresToRemove.forEach(sphere => {
                        borderInfo.remove(sphere);

                        // Limpa os recursos da esfera removida
                        sphere.geometry.dispose();
                        sphere.material.dispose();
                    });
                }
            }

            // Se o SES está ativo, atualiza a posição do cursor "Brush"
            if (this.$store.state.editor3D.currentAction === 'smoothingEdges') {
                const intersection = this.getPointOnModel(event, this.brushMesh);
                if (intersection) {
                    if (this.brushMesh) {
                        this.brushMesh.position.copy(intersection.point);
                        this.renderer.render(this.scene, this.camera);
                    }
                }
            } if (this.isDragging && this.selectedSphere) {
                const intersection = this.getPointOnModel(event, this.selectedSphere);
                if (intersection) {
                    // Atualize a posição da esfera selecionada
                    this.selectedSphere.position.copy(intersection.point);
                    const pointIndex = this.selectedSphere.userData.pointIndex;
                    this.$store.dispatch('editor3D/updateContourPoint', { index: pointIndex, newPosition: intersection.point });
                    this.renderer.render(this.scene, this.camera);
                    // Se necessário, atualize o contorno aqui
                    this.updateContour();
                    console.warn(this.currentMode)
                    if (this.currentMode === 'alignPlan') {
                        this.adjustArchScale('fullArch', 1.0)
                        this.alignDentalMapToArch();
                        this.alignDentalAngularToTangent();
                        this.closeGapsBetweenTeethAndGum();
                    }
                }
            }

            // if (this.mouseDownPosition) {
            //     var currentMousePosition = { x: event.clientX, y: event.clientY };
            //     var deltaX = currentMousePosition.x - this.lastMousePosition.x;
            //     var deltaY = currentMousePosition.y - this.lastMousePosition.y;

            //     var directionX = (deltaX > 0) ? 1 : -1;
            //     var directionY = (deltaY > 0) ? 1 : -1;

            //     // Determinar o eixo de rotação com base na direção do movimento
            //     var axis;
            //     if (Math.abs(deltaX) > Math.abs(deltaY)) {
            //         axis = new THREE.Vector3(0, directionX, 0); // Rotação em torno do eixo Y
            //     } else {
            //         axis = new THREE.Vector3(directionY, 0, 0); // Rotação em torno do eixo X
            //     }

            //     // Aplicar a rotação em torno do eixo determinado
            //     var angle = Math.sqrt(deltaX * deltaX + deltaY * deltaY) * Math.PI / 180; // Ângulo de rotação

            //     var sensivity = 0.25;
            //     // eslint-disable-next-line no-unused-vars
            //     var rotationMatrix = new THREE.Matrix4().makeRotationAxis(axis, sensivity * angle);
            //     this.scene.traverse(function (child) {
            //         // Verificar se child é uma instância válida de Object3D ou Mesh
            //         if (child instanceof THREE.Object3D && (child instanceof THREE.Mesh || child instanceof THREE.Group)) {
            //             // Aplicar a rotação para cada objeto Object3D ou Mesh na cena
            //             //child.applyMatrix4(rotationMatrix);
            //         }
            //     });


            //     this.lastMousePosition = currentMousePosition;
            // }

            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            // Verifique se o mousedown ocorreu em um objeto controlado pelo transformControl
            let raycaster = new THREE.Raycaster();

            // Configura o raycaster a partir da câmera e da posição do mouse
            raycaster.setFromCamera(this.mouse, this.camera);

            const intersects = raycaster.intersectObject(this.transformControl, true);
            if (intersects.length > 0) {
                this.transformControl.children.forEach(child => {
                    if (child.type === 'TransformControlsGizmo') {
                        child.visible = true;
                    }
                });
            }
        },
        onDocumentMouseUp(event) {
            this.isDragging = false;
            this.selectedSphere = null;
            this.controls.enabled = true; // Reativa os controles de câmera após o arrasto
            if (event.button === 0 && this.$store.state.editor3D.currentAction === 'smoothingEdges') {
                this.isMouseDown = false;
            }

            if (event.button === 1) {
                // Chama o método para atualizar o foco da câmera com base nas arcadas dentárias
                //this.updateCameraFocusBasedOnDentalArches();
                //this.controls.target.copy(this.camera.getWorldDirection(new THREE.Vector3()));
                //this.controls.update();
                //this.camera.lookAt(0, 0, 0);
                //console.table(this.camera.getWorldDirection(new THREE.Vector3()));
                //console.table(this.camera)
                //console.warn('Update focus')
                this.transformControl.mode = this.transformControl.mode === 'rotate' ? 'translate' : 'rotate';
            }

            this.mouseDownPosition = null;

            if (!this.transformControl.dragging) {
                this.transformControl.children.forEach(child => {
                    if (child.type === 'TransformControlsGizmo') {
                        child.visible = false;
                    }
                });
            }

        },

    },
    mounted() {
        this.initThree();
        this.processExecutedTasks();
        this.processPendingTasks();
        window.addEventListener('resize', this.onWindowResize);
        document.documentElement.style.overflowY = 'hidden';
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
        this.renderer.domElement.addEventListener('click', this.handleModelClick);
        document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, false);
        this.renderer.domElement.addEventListener('mousedown', this.onDocumentMouseDown);
        window.addEventListener('mousemove', this.onDocumentMouseMove);
        window.addEventListener('mouseup', this.onDocumentMouseUp);



        //this.initializeModel();
        //this.loadAllModels();
    },
    beforeUnmount() {
        this.stopAnimate();
        if (this.renderer) {
            this.renderer.dispose();
        }
        window.removeEventListener('resize', this.onWindowResize);
        document.documentElement.style.overflowY = null;
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
        this.renderer.domElement.removeEventListener('click', this.handleModelClick);

        this.renderer.domElement.removeEventListener('mousedown', this.onDocumentMouseDown);
        window.removeEventListener('mousemove', this.onDocumentMouseMove);
        window.removeEventListener('mouseup', this.onDocumentMouseUp);

        if (process.env.VUE_APP_CLEAR_TASKS == "yes") {
            console.warn("Fila de tarefas removida")
            this.$store.dispatch('editor3D/clearTasks');
        }


    },
    computed: {
        currentPath() {
            return this.$route.path // retorna "/video", por exemplo
        },
        currentContext() {
            const parts = this.$route.path.split('/')
            return parts[parts.length - 1] || 'home'
        },
        backgroundColor() {
            switch (this.currentContext) {
                case 'video':
                    return '#EAF7FB'
                case 'editor':
                    return '#F5E3C4'
                default:
                    return '#fff'
            }
        },
        bottomBarItems() {
            switch (this.currentContext) {
                case 'video':
                    return this.bottomBarItems_video
                case 'editor':
                    return this.bottomBarItems_editor
                default:
                    return []
            }
        },
        hasImages() {
            // Verifica se há pelo menos uma imagem disponível
            return this.xyHeatmap || this.xzHeatmap || this.yzHeatmap ||
                this.xyDensitymap || this.xzDensitymap || this.yzDensitymap;
        },
        tasks() {
            return this.$store.state.editor3D.tasks;
        },
        currentAction() {
            return this.$store.state.editor3D.currentAction;
        },
        centroid() {
            const contourPoints = this.$store.getters['editor3D/contourPoints'];
            let centroid = new THREE.Vector3();
            contourPoints.forEach(point => {
                centroid.add(new THREE.Vector3(point.x, point.y, point.z));
            });
            centroid.divideScalar(contourPoints.length);
            return centroid;
        }
    },
    watch: {
        currentContext() {
            this.renderer.setClearColor(this.backgroundColor)
        },
        // Sempre que uma das imagens for atualizada, o dialog é mostrado se houver imagens
        hasImages(newValue) {
            if (newValue) {
                this.dialogVisible = true;
            } else {
                this.dialogVisible = false;
            }
        },
        tasks(newTasks) {
            newTasks.forEach(task => {
                if (!task.executed) {
                    this.processTask(task);
                }
            })
        },
        currentAction(newAction, oldAction) {
            if (newAction !== oldAction) {
                this.$store.dispatch('editor3D/clearOcclusionPlanData');
                this.removeAllHelperObjects();
            }
        },
        'this.$store.getters["editor3D/contourPoints"]': {
            handler() {
                this.updateContour();
            },
            deep: true,
        },
    },
};

</script>

<style scoped>
.threejs-canvas-container {
    width: 100%;
    height: 95vh;
    overflow: hidden;
}

.v-container {
    padding: 1px !important;
}

.img-heat img {
    width: 50%;
    height: 50%;
}

.btn-nav {
    width: 120px;
    /* Largura fixa para todos os botões */
    height: 80px;
    /* Altura fixa para todos os botões */
}

.v-input__details {
    display: none;
}

.hud {
    position: absolute;
    top: 80px;
    right: 20px;
    background: rgba(0, 0, 0, 0.7);
    padding: 15px;
    border-radius: 8px;
    color: white;
}

.hud-item {
    display: flex;
    align-items: center;
    margin: 8px 0;
}

.icon {
    font-size: 1.2em;
    margin-right: 10px;
}

.value {
    font-size: 0.9em;
    letter-spacing: 0.5px;
}

.cycle-control {
    background: rgba(0, 0, 0, 0.7);
    padding: 2px;
    border-radius: 5px;
}

.adjustments-log {

    background: rgba(0, 0, 0, 0.7);
    padding: 2px;
    border-radius: 5px;
    max-height: 300px;
    overflow-y: auto;
}

.adjustments-log ul {
    list-style: none;
    padding: 0;
}

.adjustments-log li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
}

.ajuste-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
}

.tempo-central {
    font-size: 24px;
    font-weight: bold;
    width: 100px;
    text-align: center;
}
</style>
